import Icon from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";

const MailSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M461.9,72.3H50.1c-25.9,0-47.3,19.8-49.9,45.1l221.5,221.5c17.8,17.8,49.8,18.8,69.7-1.1l220.4-220.4C509.2,92.2,487.8,72.3,461.9,72.3z M315,361.4c-15.8,15.8-36.8,24.5-59.3,24.5c-21.8,0-42.7-8.5-57.6-23.4L0,164.4v225.1c0,27.6,22.5,50.1,50.1,50.1h411.8c27.6,0,50.1-22.5,50.1-50.1V164.4L315,361.4z" />
  </svg>
);

const LockSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M423,211.5h-16.7v-61.2C406.3,67.4,338.9,0,256,0S105.7,67.4,105.7,150.3v61.2H89c-27.6,0-50.1,22.5-50.1,50.1v200.3C39,489.5,61.4,512,89,512H423c27.6,0,50.1-22.5,50.1-50.1V261.6C473,233.9,450.6,211.5,423,211.5z M272.7,375.4v53.2c0,9.2-7.5,16.7-16.7,16.7c-9.2,0-16.7-7.5-16.7-16.7v-53.2c-19.4-6.9-33.4-25.2-33.4-47c0-27.7,22.4-50.1,50.1-50.1c27.7,0,50.1,22.4,50.1,50.1C306.1,350.1,292.1,368.5,272.7,375.4z M339.5,211.5h-167v-61.2c0-46,37.4-83.5,83.5-83.5s83.5,37.4,83.5,83.5L339.5,211.5L339.5,211.5z" />
  </svg>
);

const UserSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M256,0C114.8,0,0,114.8,0,256s114.8,256,256,256s256-114.8,256-256S397.2,0,256,0z M256,478.6c-64.7,0-122.8-27.9-163.5-72.1c20.7-40.6,55.5-71.6,97.1-87.9c-30.4-21.1-50.4-56.3-50.4-96c0-64.4,52.4-116.9,116.9-116.9s116.9,52.4,116.9,116.9c0,39.8-20,74.9-50.4,96c41.6,16.2,76.5,47.2,97.2,87.8C378.9,450.7,320.7,478.6,256,478.6z" />
  </svg>
);

const PhoneSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M497.4,331.7l-61-61.1c-19.5-19.5-51.3-19.5-70.8,0l-42.3,46.2l131.9,131.9l42.3-46.2C516.9,383,516.9,351.2,497.4,331.7zM39.6,80.5L27.8,92.3C9.3,110.8,0,132.9,0,157.8C0.1,234.1,79,309,141.1,370.9c60.6,60.8,136.4,141,213.1,141.1c0,0,0.1,0,0.1,0c24.9,0,46.9-9.4,65.3-27.8l11.8-11.8L39.6,80.5z M241.4,75.7l-61.1-61.1c-19.6-19.5-51.3-19.5-70.8,0L63.3,56.9l131.9,131.9l46.2-42.3C260.9,127,260.9,95.2,241.4,75.7z" />
  </svg>
);

const ProfileUserSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path
      transform="translate(384.953 273.107)"
      d="M-334.7-225.4c5.4,0,9.8-4.4,9.8-9.8c0-5.4-4.4-9.8-9.8-9.8c-5.4,0-9.8,4.4-9.8,9.8c0,0,0,0,0,0C-344.6-229.8-340.2-225.4-334.7-225.4z M-334.7-240.8c3.1,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5c-3.1,0-5.5-2.5-5.5-5.5C-340.3-238.3-337.8-240.8-334.7-240.8C-334.7-240.8-334.7-240.8-334.7-240.8L-334.7-240.8z M-349.8-201.1h30.2c1.1,0,2.1-0.8,2.1-2c0,0,0-0.1,0-0.1v-4.8c0.1-9.5-7.6-17.3-17.1-17.4c-9.5-0.1-17.3,7.6-17.4,17.1c0,0.1,0,0.2,0,0.3v4.8C-352-202-351-201.1-349.8-201.1C-349.9-201.1-349.9-201.1-349.8-201.1L-349.8-201.1z M-347.6-208c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v2.6h-25.8V-208z"
    />
  </svg>
);

const MedalDoneSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
    <path d="M18,6.4c-4.1,0-7.4,3.3-7.4,7.4c0,4.1,3.3,7.4,7.4,7.4c4.1,0,7.4-3.3,7.4-7.4C25.4,9.7,22.1,6.4,18,6.4z M18,19.4c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6c0,0,0,0,0,0C23.6,16.9,21.1,19.4,18,19.4z M18,22c-1.6,0-3.1-0.4-4.4-1.3l-0.4,8.9l4.3-3.7c0.3-0.3,0.7-0.3,1,0l4.3,3.7l-0.4-8.9  C21.1,21.6,19.6,22,18,22z M18,12.8c-0.5,0-1,0.4-1,0.9c0,0.5,0.4,1,0.9,1c0.5,0,1-0.4,1-0.9c0,0,0,0,0,0C18.9,13.2,18.5,12.8,18,12.8C18,12.8,18,12.8,18,12.8L18,12.8z M18,9c-2.6,0-4.8,2.1-4.8,4.8s2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8C22.8,11.1,20.6,9,18,9C18,9,18,9,18,9L18,9z M18,15.6c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8S19,15.6,18,15.6z" />
  </svg>
);

const PlusSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M28.2,20c0-0.7-0.6-1.3-1.3-1.3h-5.5v-5.5c0-0.7-0.6-1.3-1.4-1.3c-0.7,0-1.3,0.6-1.3,1.3l0,5.5h-5.5c-0.7,0-1.3,0.7-1.3,1.4c0,0.7,0.6,1.3,1.3,1.3l5.5,0l0,5.5c0,0.7,0.6,1.3,1.3,1.4c0.7,0,1.3-0.6,1.4-1.3l0,0l0-5.5l5.5,0C27.6,21.3,28.2,20.7,28.2,20z" />
  </svg>
);

const CrossSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M25.8,14.2c-0.5-0.5-1.4-0.5-1.9,0L20,18.1l-3.9-3.9c-0.5-0.5-1.4-0.5-1.9,0.1c-0.5,0.5-0.5,1.3,0,1.8l3.9,3.9l-3.9,3.9c-0.5,0.5-0.5,1.4,0.1,1.9c0.5,0.5,1.3,0.5,1.8,0l3.9-3.9l3.9,3.9c0.5,0.5,1.4,0.5,1.9,0c0.5-0.5,0.5-1.4,0-1.9l0,0L21.9,20l3.9-3.9C26.3,15.6,26.3,14.7,25.8,14.2z" />
  </svg>
);

const CloseSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <polygon points="30,12.1 27.9,10 20,17.9 12.1,10 10,12.1 17.9,20 10,27.9 12.1,30 20,22.1 27.9,30 30,27.9 22.1,20 " />
  </svg>
);

const PassportSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 501 501">
    <path d="M55.6,308.8h130V170h-130V308.8z M121.8,177.5c15.6,0,28.3,12.7,28.3,28.3s-12.7,28.3-28.3,28.3s-28.3-12.7-28.3-28.3S106.1,177.5,121.8,177.5z M69.8,281.7c-0.1-12.1,4.7-23.7,13.2-32.3c8.6-8.6,20.2-13.4,32.3-13.4h12.6c12.1,0,23.7,4.8,32.2,13.4c8.6,8.6,13.3,20.2,13.2,32.3v7.9h0.2c0,4.8-3.5,9.3-8.5,9.3H78.4c-4.8,0-8.6-4.3-8.6-9.3C69.8,289.6,69.8,281.7,69.8,281.7zM171.2,64.8H14.3C6.8,64.9,0.7,71,0.5,78.5V407c0.2,7.5,6.3,13.4,13.8,13.4h156.9c14.6,0,29.2,2.9,42.6,8.7c8.5,3.6,17.5,5.9,26.8,6.8V81.2c-11.7-1.1-23-4.1-33.8-8.7C195.5,67.5,183.4,64.9,171.2,64.8zM203.1,317.6c0,4.8-4,8.8-8.8,8.8H46.8c-4.8,0-8.8-4-8.8-8.8V161.2c0-4.8,4-8.8,8.8-8.8h147.6c4.8,0,8.8,4,8.8,8.8V317.6zM156.2,281.2H87.4c0.3-15.3,12.8-27.5,28.1-27.5H128C143.3,253.8,155.8,265.9,156.2,281.2z M486.7,64.8h-158c-12.4,0.1-24.8,2.6-36.1,7.7c-10.9,4.8-22.5,7.8-34.4,8.7v355c9.5-0.8,18.6-3.1,27.3-6.8c13.7-5.8,28.3-8.7,43.2-8.7h158c7.3,0,13.8-6.2,13.8-13.4V78.5C500.3,71,494.2,64.9,486.7,64.8z M315.9,127.2h49.8c4.8,0,8.8,4,8.8,8.8s-4,8.8-8.8,8.8h-49.8c-4.8,0-8.8-4-8.8-8.8C307.1,131.1,311.1,127.2,315.9,127.2z M442.8,351.8H315.9c-4.8,0-8.8-4-8.8-8.8c0-4.8,4-8.8,8.8-8.8h126.9c4.8,0,8.8,4,8.8,8.8C451.6,347.9,447.6,351.8,442.8,351.8z M442.8,282.4H315.9c-4.8,0-8.8-4-8.8-8.8c0-4.8,4-8.8,8.8-8.8h126.9c4.8,0,8.8,4,8.8,8.8C451.6,278.5,447.6,282.4,442.8,282.4z M442.8,213.1H315.9c-4.8,0-8.8-4-8.8-8.8c0-4.8,4-8.8,8.8-8.8h126.9c4.8,0,8.8,4,8.8,8.8C451.6,209.1,447.6,213.1,442.8,213.1z M111.1,205.7c0-5.9,4.7-10.7,10.7-10.7c5.9,0,10.7,4.7,10.7,10.7s-4.7,10.7-10.7,10.7C115.9,216.2,111.2,211.5,111.1,205.7z" />
  </svg>
);

const CertificateSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 501 501">
    <path d="M122,163.1c-29.5,0-53.3,23.8-53.3,53.3s23.8,53.3,53.3,53.3s53.3-23.8,53.3-53.3C175.3,187,151.3,163.1,122,163.1z M122,288.9c-10.1,0-20.2-2.2-29.5-6.3l-1.9,47.2l23.4-20.2c4.6-4.2,11.6-4.2,16.2,0l23.4,20.2l-1.9-47.2C142.4,286.9,132.3,288.9,122,288.9z M486,79.6H15c-8,0-14.5,6.5-14.5,14.5v312.8c0,8,6.5,14.5,14.5,14.5h471c8,0,14.5-6.5,14.5-14.5V94.1C500.5,86.1,494,79.6,486,79.6z M240.8,162.9h109.9c5.3,0,9.7,4.3,9.7,9.7c0,5.3-4.3,9.7-9.7,9.7H240.8c-5.3,0-9.7-4.3-9.7-9.7C231.2,167.3,235.5,162.9,240.8,162.9z M173.6,346.4c0,4.7-2.8,8.9-7,11c-1.6,0.7-3.3,1.1-5,1.1c-2.9,0-5.7-1.1-7.9-2.9l-31.6-27.3l-31.6,27.3c-3.5,3.1-8.6,3.9-12.8,1.8c-4.2-2.1-7-6.3-7-11V346l3.1-75.5c-22.5-20-30.2-51.9-19.6-80.1c10.7-28.1,37.7-46.7,67.9-46.7s57.1,18.6,67.9,46.7c10.7,28.1,2.9,60-19.6,80.1L173.6,346.4zM442.5,339.3H240.8c-5.3,0-9.7-4.3-9.7-9.7c0-5.3,4.3-9.7,9.7-9.7h201.7c5.3,0,9.7,4.3,9.7,9.7C452.2,334.9,447.8,339.3,442.5,339.3z M442.5,287.3H240.8c-5.3,0-9.7-4.3-9.7-9.7s4.3-9.7,9.7-9.7h201.7c5.3,0,9.7,4.3,9.7,9.7S447.8,287.3,442.5,287.3z M442.5,234.2H240.8c-5.3,0-9.7-4.3-9.7-9.7c0-5.3,4.3-9.7,9.7-9.7h201.7c5.3,0,9.7,4.3,9.7,9.7C452.2,229.8,447.8,234.2,442.5,234.2z" />
  </svg>
);

const DiplomaSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 501 501">
    <path d="M1.3,381.1c-1.9,5.9,8.8,34.7,46.7,72.5c37.3,37.3,65.6,48.2,72.1,46.7l0.4-0.4c1.5-6.5-9.4-34.9-46.7-72.1C35.8,389.9,7.2,379.3,1.3,381.1z M176.7,205.5c-1,1-2.3,1.8-3.6,2.3L17.2,363.7c5.3,1.9,10.4,4.1,15.5,6.8c17.2,9.3,36.9,24.6,55.4,43.1s33.8,38.2,43.1,55.4c2.5,4.5,4.6,9.2,6.4,14.1l158.8-158.8c1.4-6.5-9.5-35-46.7-72.1C211.1,213.7,182.1,203.3,176.7,205.5z M380.2,0.8l-134,134c5.3,1.9,10.4,4.1,15.5,6.9c17.2,9.3,36.9,24.6,55.4,43.1s33.8,38.2,43.1,55.4c2.5,4.5,4.6,9.2,6.4,14.1l126.6-126.9l6.5-6.9c2.3-5.4-8.2-34.4-46.5-72.7C414.7,9.3,385.6-1.4,380.2,0.8zM394.7,273.1h-47.5l2-2c1.4-6.5-9.5-35-46.7-72.1c-38.4-38.4-67.3-48.9-72.6-46.6c-1,1-2.3,1.8-3.6,2.3l-33.5,33.5c5.3,1.9,10.4,4.1,15.5,6.9c17.2,9.3,36.9,24.6,55.4,43.1s33.8,38.2,43.1,55.4c1.5,2.9,2.9,5.7,4,8.3v64.2c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10v-72.9h63.9c5.5,0,10-4.5,10-10C404.8,277.6,400.4,273.1,394.7,273.1z" />
  </svg>
);

const CheckSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M30.1,15.8L19.3,26.6c-0.6,0.7-1.7,0.7-2.4,0c0,0,0,0,0,0l-5.4-5.4c-0.7-0.7-0.7-1.7,0-2.4s1.7-0.7,2.4,0l4.2,4.2l9.7-9.7c0.7-0.7,1.7-0.7,2.4,0S30.8,15.1,30.1,15.8z" />
  </svg>
);

const ArrowFullSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M24.4,19.5l-3-2.8v9.7c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3v-9.7l-3,2.8c-0.5,0.5-1.4,0.5-1.9,0s-0.5-1.4,0-1.9l0.1-0.1l5.3-4.9c0.5-0.5,1.3-0.5,1.8,0l5.3,4.9c0.3,0.2,0.4,0.6,0.4,0.9c0,0.4-0.1,0.7-0.4,1C25.7,20,24.9,20,24.4,19.5z" />
  </svg>
);

const EditSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M27.8,19.1C27.8,19,27.8,19,27.8,19.1l2.9-2.9c0.5-0.5,0.5-1.4,0-1.9l-5-4.9c-0.3-0.2-0.6-0.4-1-0.4c-0.4,0-0.7,0.1-1,0.4L21,12.2c0,0,0,0-0.1,0c0,0,0,0-0.1,0.1L10.7,22.5c-0.2,0.2-0.3,0.4-0.4,0.7l-1.4,6.3c-0.1,0.4,0,0.8,0.3,1.1c0.3,0.3,0.7,0.5,1.1,0.5c0.1,0,0.2,0,0.3,0l6.3-1.4c0.2,0,0.5-0.2,0.7-0.4L27.8,19.1C27.7,19.1,27.7,19.1,27.8,19.1z M15.9,27.1L12,28l0.9-3.9l9-9l3,3L15.9,27.1z M23.8,13.2l1-1.1l3.1,3.1l-1,1L23.8,13.2z" />
  </svg>
);

const DeleteSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M25.8,14.2c-0.5-0.5-1.4-0.5-1.9,0L20,18.1l-3.9-3.9c-0.5-0.5-1.4-0.5-1.9,0.1c-0.5,0.5-0.5,1.3,0,1.8l3.9,3.9l-3.9,3.9c-0.5,0.5-0.5,1.4,0.1,1.9c0.5,0.5,1.3,0.5,1.8,0l3.9-3.9l3.9,3.9c0.5,0.5,1.4,0.5,1.9,0c0.5-0.5,0.5-1.4,0-1.9l0,0L21.9,20l3.9-3.9C26.3,15.6,26.3,14.7,25.8,14.2z" />
  </svg>
);

const ShowSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M20.1,9c-9.4,0-16.7,9.9-17,10.3c-0.4,0.5-0.4,1.1,0,1.6c0.3,0.4,7.6,10.3,17,10.3s16.7-9.9,17-10.3c0.4-0.5,0.4-1.1,0-1.6C36.8,18.9,29.5,9,20.1,9z M20.1,28.5c-6.6,0-12.4-6.2-14.2-8.4c1.9-2.2,7.6-8.4,14.2-8.4c6.6,0,12.4,6.2,14.2,8.4C32.5,22.3,26.7,28.5,20.1,28.5z M20.1,12.4c-4.3,0-7.7,3.5-7.7,7.7c0,4.3,3.5,7.7,7.7,7.7c4.3,0,7.7-3.5,7.7-7.7C27.9,15.8,24.4,12.4,20.1,12.4L20.1,12.4z M20.1,25.2c-2.8,0-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1   c2.8,0,5.1,2.3,5.1,5.1S22.9,25.2,20.1,25.2C20.1,25.2,20.1,25.2,20.1,25.2L20.1,25.2z" />
  </svg>
);

const WalletSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M376,383.5L376,383.5c-24.6,0-44.5-19.9-44.5-44.5v-73.9c0-24.6,19.9-44.5,44.5-44.5h116h2.1V147c0-18.9-15.4-34.3-34.3-34.3H34.3C15.4,112.7,0,128,0,147v310c0,18.9,15.4,34.3,34.3,34.3h425.5c18.9,0,34.3-15.4,34.3-34.3v-73.6H492L376,383.5z M492,244.9H375.9c-11.1,0-20.1,9-20.1,20.1V339c0,11.1,9,20.1,20.1,20.1h116c11.1,0,20.1-9,20.1-20.1v-73.9C512,254,503.1,245,492,244.9z M416,331c-16,0-29-13-29-29s13-29,29-29c16,0,29,13,29,29S432,331,416,331L416,331z M400,49.8c-7.7-23.2-32.7-35.8-56-28.2c0,0,0,0,0,0L169.7,79.3h240L400,49.8z" />
  </svg>
);

const FacebookSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.55 40H22.22V23.63H17.06V18.63H22.22V12.46C22.2502 10.9882 22.8343 9.58188 23.8556 8.52165C24.8769 7.46143 26.2603 6.82524 27.73 6.73999H33.27V11.26H30.84C29.36 11.26 27.55 12.48 27.55 13.9V18.64H32.75V23.64H27.55V40Z"
    />
  </svg>
);

const InstagramSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.3027 19.96C29.304 18.7396 29.0647 17.531 28.5984 16.4033C28.1321 15.2756 27.448 14.251 26.5853 13.388C25.7226 12.5251 24.6982 11.8409 23.5708 11.3745C22.4434 10.9081 21.235 10.6687 20.015 10.67C17.5517 10.67 15.1894 11.6488 13.4476 13.391C11.7058 15.1332 10.7273 17.4961 10.7273 19.96C10.726 21.1808 10.9653 22.3899 11.4314 23.5182C11.8976 24.6465 12.5815 25.6718 13.4441 26.5355C14.3066 27.3992 15.3309 28.0844 16.4584 28.5519C17.5859 29.0194 18.7945 29.26 20.015 29.26C21.2355 29.26 22.444 29.0194 23.5715 28.5519C24.699 28.0844 25.7233 27.3992 26.5859 26.5355C27.4485 25.6718 28.1324 24.6465 28.5986 23.5182C29.0647 22.3899 29.304 21.1808 29.3027 19.96ZM29.1327 9.41C28.7367 9.40999 28.3568 9.56665 28.0758 9.84579C27.7949 10.1249 27.6357 10.5039 27.6331 10.9C27.6331 11.2978 27.7911 11.6794 28.0723 11.9607C28.3536 12.242 28.735 12.4 29.1327 12.4C29.5287 12.3974 29.9076 12.2382 30.1867 11.9571C30.4657 11.6761 30.6223 11.2961 30.6223 10.9C30.6223 10.5048 30.4654 10.1258 30.186 9.8464C29.9067 9.56698 29.5278 9.41 29.1327 9.41ZM12.4269 7.25999H27.6131C28.9664 7.26526 30.2628 7.80533 31.2197 8.7625C32.1766 9.71967 32.7166 11.0164 32.7218 12.37V27.56C32.7166 28.9136 32.1766 30.2103 31.2197 31.1675C30.2628 32.1247 28.9664 32.6647 27.6131 32.67H12.3769C11.0306 32.6543 9.74439 32.1096 8.79607 31.1535C7.84774 30.1975 7.31332 28.9068 7.30816 27.56V12.37C7.31342 11.0164 7.85335 9.71967 8.81029 8.7625C9.76722 7.80533 11.0636 7.26526 12.4169 7.25999H12.4269ZM27.6131 5.56H12.3769C10.572 5.56264 8.84186 6.28097 7.56563 7.55752C6.2894 8.83407 5.57125 10.5647 5.5686 12.37V27.56C5.57125 29.3653 6.2894 31.0959 7.56563 32.3725C8.84186 33.649 10.572 34.3673 12.3769 34.37H27.5631C29.368 34.3673 31.0981 33.649 32.3744 32.3725C33.6506 31.0959 34.3688 29.3653 34.3714 27.56V12.37C34.3688 10.5647 33.6506 8.83407 32.3744 7.55752C31.0981 6.28097 29.368 5.56264 27.5631 5.56H27.6131ZM12.6168 19.96C12.6195 18.0088 13.3956 16.1383 14.7749 14.7586C16.1543 13.3789 18.0243 12.6026 19.975 12.6C21.9274 12.6 23.8 13.3751 25.1815 14.7551C26.563 16.1351 27.3405 18.0071 27.3432 19.96C27.3432 21.9146 26.5669 23.7892 25.1851 25.1714C23.8033 26.5535 21.9292 27.33 19.975 27.33C18.0226 27.3273 16.151 26.5497 14.7714 25.1678C13.3917 23.786 12.6168 21.9129 12.6168 19.96Z"
    />{" "}
  </svg>
);

const VkSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2867 28.8133C12.1667 28.8133 6.96666 22.5667 6.75333 12.1467H11.3333C11.4867 19.78 14.8533 23.0133 17.52 23.68V12.1467H21.82V18.7267C24.4867 18.4467 27.22 15.4467 28.1533 12.1467H32.4533C32.1001 13.858 31.3981 15.4782 30.391 16.9062C29.3839 18.3342 28.0934 19.5394 26.6 20.4467C28.268 21.2737 29.7414 22.4453 30.9228 23.8842C32.1042 25.323 32.9667 26.9963 33.4533 28.7933H28.72C27.7067 25.6267 25.1667 23.18 21.82 22.8467V28.7933L21.2867 28.8133Z"
    />
  </svg>
);

const YoutubeSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.19 9.90997C35.7164 10.4363 36.0956 11.0914 36.29 11.81C36.7747 14.5026 37.009 17.2342 36.99 19.97C37.0075 22.7128 36.7698 25.4513 36.28 28.15C36.0838 28.8677 35.704 29.5218 35.1779 30.0479C34.6518 30.574 33.9977 30.9538 33.28 31.15C30.63 31.86 20 31.86 20 31.86C20 31.86 9.37 31.86 6.71 31.15C5.99143 30.9557 5.33632 30.5764 4.80996 30.05C4.2836 29.5237 3.90435 28.8686 3.71 28.15C3.22021 25.4513 2.98251 22.7128 2.99999 19.97C2.98241 17.2239 3.22011 14.4821 3.71 11.78C3.90343 11.061 4.28237 10.4054 4.80888 9.87888C5.33538 9.35238 5.99097 8.97344 6.71 8.78001C9.37 8.07001 20 8.07001 20 8.07001C20 8.07001 30.63 8.07001 33.29 8.81001C34.0086 9.00436 34.6637 9.38361 35.19 9.90997ZM25.43 20L16.6 25.1V14.9L25.43 20Z"
    />
  </svg>
);

const TwitterSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M33.3333 11.7293C32.3346 12.1716 31.2753 12.4619 30.1907 12.5907C31.3311 11.906 32.184 10.8304 32.5907 9.56399C31.5173 10.203 30.3426 10.6539 29.1173 10.8973C28.2928 10.0194 27.2018 9.43793 26.0134 9.24288C24.8249 9.04782 23.6053 9.25011 22.5435 9.81839C21.4816 10.3867 20.6368 11.2893 20.1398 12.3863C19.6429 13.4834 19.5216 14.7137 19.7947 15.8867C17.6192 15.7781 15.4908 15.2131 13.5479 14.2283C11.6051 13.2435 9.89107 11.861 8.51732 10.1707C7.81832 11.3753 7.60433 12.8009 7.91888 14.1577C8.23343 15.5145 9.05289 16.7005 10.2107 17.4747C9.34212 17.4476 8.49268 17.2131 7.73332 16.7907C7.73332 16.8133 7.73332 16.836 7.73332 16.86C7.73379 18.1232 8.17108 19.3474 8.97107 20.325C9.77105 21.3027 10.8845 21.9736 12.1227 22.224C11.317 22.4434 10.4719 22.4753 9.65199 22.3173C10.0024 23.4042 10.6839 24.3542 11.601 25.0347C12.518 25.7151 13.6249 26.0917 14.7667 26.112C12.4702 27.9042 9.55975 28.7186 6.66666 28.3787C9.16825 29.9862 12.0797 30.8398 15.0533 30.8373C25.116 30.8373 30.6187 22.5 30.6187 15.2707C30.6187 15.0333 30.6133 14.7973 30.6027 14.5627C31.6744 13.7884 32.5992 12.8289 33.3333 11.7293Z" />
  </svg>
);

const YandexZenSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M40 20.2143V19.7857C31.1429 19.5 27.1 19.2857 23.8571 16.1429C20.7143 12.9 20.4857 8.85714 20.2143 0H19.7857C19.5 8.85714 19.2857 12.9 16.1429 16.1429C12.9 19.2857 8.85714 19.5143 0 19.7857V20.2143C8.85714 20.5 12.9 20.7143 16.1429 23.8571C19.2857 27.1 19.5143 31.1429 19.7857 40H20.2143C20.5 31.1429 20.7143 27.1 23.8571 23.8571C27.1 20.7143 31.1429 20.4857 40 20.2143Z" />
  </svg>
);

const OkSvg = () => (
  <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.7195 26.1706C25.5931 25.5822 27.3151 24.2144 27.4062 24.141C28.2471 23.4631 28.3822 22.2285 27.7078 21.3832C27.0336 20.538 25.8053 20.4023 24.9642 21.08C24.9465 21.0944 23.1098 22.5106 20.0879 22.5126C17.066 22.5106 15.1905 21.0944 15.1728 21.08C14.3317 20.4023 13.1034 20.538 12.4292 21.3832C11.7548 22.2285 11.8899 23.4631 12.7308 24.141C12.8231 24.2154 14.6162 25.6189 17.5704 26.1934L13.4532 30.5183C12.705 31.2982 12.7275 32.5401 13.5034 33.2921C13.8822 33.6592 14.3703 33.8416 14.858 33.8416C15.3694 33.8416 15.8802 33.6408 16.2631 33.2415L20.088 29.1462L24.2991 33.2681C25.0621 34.0338 26.2977 34.0325 27.0592 33.2659C27.8208 32.4992 27.8199 31.2571 27.0571 30.4916L22.7195 26.1706Z" />
    <path d="M20.1853 6C16.221 6 13.0073 9.23021 13.0073 13.2148C13.0073 17.1994 16.221 20.4298 20.1853 20.4298C24.1496 20.4298 27.3632 17.1994 27.3632 13.2148C27.3632 9.23021 24.1496 6 20.1853 6ZM20.1853 16.1974C18.5466 16.1974 17.2181 14.862 17.2181 13.2149C17.2181 11.5677 18.5466 10.2324 20.1853 10.2324C21.824 10.2324 23.1525 11.5677 23.1525 13.2149C23.1525 14.862 21.824 16.1974 20.1853 16.1974Z" />
  </svg>
);

const DocumentSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20.908" height="26" viewBox="0 0 512 512">
    <path d="M461.9,16.7c0-9.2-7.5-16.7-16.7-16.7H66.8c-9.2,0-16.7,7.5-16.7,16.7v50v66.9V167h0v278.3h0v10.1h0v40c0,9.2,7.5,16.7,16.7,16.7h378.4c9.2,0,16.7-7.5,16.7-16.7V460h0V16.7z M133.6,66.7h244.9c9.2,0,16.7,7.6,16.7,16.8c0,9.2-7.5,16.7-16.7,16.7H133.6c-9.2,0-16.7-7.5-16.7-16.7C116.9,74.3,124.3,66.7,133.6,66.7z M378.4,378.4H133.6c-9.2,0-16.7-7.5-16.7-16.7c0-9.2,7.5-16.8,16.7-16.8h244.9c9.2,0,16.7,7.6,16.7,16.8C395.1,371,387.7,378.4,378.4,378.4zM395.1,428.5c0,9.2-7.5,16.7-16.7,16.7H133.6c-9.2,0-16.7-7.5-16.7-16.7c0-9.2,7.5-16.8,16.7-16.8h244.9C387.7,411.7,395.1,419.3,395.1,428.5z M116.9,150.3c0-9.2,7.5-16.8,16.7-16.8h244.9c9.2,0,16.7,7.6,16.7,16.8V295h0c0,9.2-7.5,16.7-16.7,16.7H133.6c-9.2,0-16.7-7.5-16.7-16.7V150.3z" />
  </svg>
);

const TelegramSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M8.32376 19.8265C8.32376 19.8265 18.3238 15.7225 21.7919 14.2774C23.1214 13.6994 27.6301 11.8497 27.6301 11.8497C27.6301 11.8497 29.711 11.0405 29.5376 13.0057C29.4798 13.815 29.0174 16.6473 28.555 19.7109C27.8613 24.0462 27.1098 28.7861 27.1098 28.7861C27.1098 28.7861 26.9942 30.1156 26.0116 30.3468C25.029 30.578 23.4104 29.5376 23.1214 29.3063C22.8902 29.1329 18.7862 26.5317 17.2833 25.2601C16.8786 24.9133 16.4162 24.2197 17.341 23.4104C19.422 21.5029 21.9075 19.1329 23.4104 17.6301C24.1041 16.9364 24.7977 15.3179 21.9075 17.2832C17.8035 20.1156 13.7573 22.7745 13.7573 22.7745C13.7573 22.7745 12.8324 23.3525 11.0983 22.8323C9.36416 22.3121 7.34104 21.6185 7.34104 21.6185C7.34104 21.6185 5.95384 20.7514 8.32376 19.8265Z" />
  </svg>
);

/* message icons */
const WarningSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M20,23L20,23c-0.9,0-1.7-0.8-1.7-1.7v-9.4c0-0.9,0.8-1.7,1.7-1.7l0,0c0.9,0,1.7,0.8,1.7,1.7v9.4C21.7,22.2,20.9,23,20,23z M20,26.4c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7S19.1,26.4,20,26.4z" />
  </svg>
);

const InfoSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M20,17L20,17c0.9,0,1.7,0.8,1.7,1.7v9.4c0,0.9-0.8,1.7-1.7,1.7l0,0c-0.9,0-1.7-0.8-1.7-1.7v-9.4C18.3,17.8,19.1,17,20,17z M20,10.2c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7S19.1,10.2,20,10.2z" />
  </svg>
);

const SuccessSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M30.1,15.8L19.3,26.6c-0.6,0.7-1.7,0.7-2.4,0c0,0,0,0,0,0l-5.4-5.4c-0.7-0.7-0.7-1.7,0-2.4s1.7-0.7,2.4,0l4.2,4.2l9.7-9.7c0.7-0.7,1.7-0.7,2.4,0S30.8,15.1,30.1,15.8z" />
  </svg>
);

const ErrorSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path
      d="M25.8,14.2c-0.5-0.5-1.4-0.5-1.9,0L20,18.1l-3.9-3.9c-0.5-0.5-1.4-0.5-1.9,0.1
	c-0.5,0.5-0.5,1.3,0,1.8l3.9,3.9l-3.9,3.9c-0.5,0.5-0.5,1.4,0.1,1.9c0.5,0.5,1.3,0.5,1.8,0l3.9-3.9l3.9,3.9c0.5,0.5,1.4,0.5,1.9,0
	c0.5-0.5,0.5-1.4,0-1.9l0,0L21.9,20l3.9-3.9C26.3,15.6,26.3,14.7,25.8,14.2z"
    />
  </svg>
);

const ClipSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path d="M16.6,29.1c-1.8,0-3.6-0.7-4.9-2c-2.7-2.7-2.7-7.2,0-9.9l4.7-4.7c0.5-0.5,1.3-0.5,1.9,0c0.5,0.5,0.5,1.3,0,1.9L13.5,19c-1.7,1.7-1.7,4.5,0,6.2c1.7,1.7,4.5,1.7,6.2,0l7.4-7.4c0.5-0.5,0.7-1.1,0.7-1.7c0-0.7-0.3-1.3-0.7-1.7c-1-1-2.5-1-3.5,0l-7.4,7.4c-0.2,0.2-0.2,0.6,0,0.9c0.2,0.2,0.6,0.2,0.9,0l4.7-4.7c0.5-0.5,1.3-0.5,1.9,0c0.5,0.5,0.5,1.3,0,1.9l-4.7,4.7c-1.3,1.3-3.3,1.3-4.6,0c-0.6-0.6-0.9-1.4-0.9-2.3s0.3-1.7,0.9-2.3l7.4-7.4c2-2,5.2-2,7.2,0c1,1,1.5,2.2,1.5,3.6c0,1.4-0.5,2.6-1.5,3.6L21.5,27C20.2,28.4,18.4,29.1,16.6,29.1z" />
  </svg>
);

const MessageSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M38.3,481.4c0,0,50.4-26.4,50.4-77C29.5,365.5,0,309.2,0,250.2C0,141.3,100.1,30.6,256.9,30.6c166.1,0,255.1,101.8,255.1,210c0,108.9-90,210.7-255.1,210.7c-28.9,0-59.1-3.9-86.1-10.9C133.4,477.8,38.3,481.4,38.3,481.4z" />
  </svg>
);

const ChatSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M506.1,287.1c0-0.5,0-1,0-1.5c0-0.8,0-1.5-0.1-2.3c-1.3-39.8-15.1-70.3-34.7-72l-0.8-0.1c-1.1-42-14.6-83.7-39.8-119.4C390.2,34.3,324.9,0,256,0S122,34.3,81.3,91.9c-25.2,35.8-38.7,77.5-39.8,119.5l-0.8,0.1c-23.3,2-38.5,44.8-34.1,95.6c4.4,50.8,26.9,90.3,50.3,88.3l76-6.6c6.4-0.5,12.3-3.7,16.4-8.6c4.1-4.9,6.1-11.3,5.6-17.7L143,226.9c-1.2-13.4-12.9-23.3-26.3-22.1l-20.1,1.8c1.8-29,11.6-57.7,29.6-83C156.9,80,204.3,54.9,256,54.9s99,25,129.9,68.6c17.9,25.4,27.7,53.9,29.6,82.9l-20.2-1.8c-13.4-1.2-25.2,8.7-26.3,22.1l-11.9,135.5c-0.3,3.2,0.1,6.4,1.1,9.4c0.9,3,2.5,5.9,4.5,8.4c4.1,4.9,10,8.1,16.4,8.6l27,2.4L388,432.8c-7.4,16.8-24,27.8-42.3,27.8h-32.5c-2.6-8.5-10.3-14.8-19.7-14.8h-60.2c-11.6,0-20.9,9.4-20.9,20.9v24.4c0,11.6,9.4,20.9,20.9,20.9h60.2c9.4,0,17-6.3,19.7-14.8h32.5c32.9,0,62.7-19.6,75.9-49.8l23-52.9l10.6,0.9c23.4,2,45.9-37.5,50.3-88.3C506,300.3,506.2,293.6,506.1,287.1z" />
  </svg>
);

const OrderCallSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M388.3,492c27.1,0,49.2-22,49.2-49.2v-65.6c0-7.1-4.5-13.3-11.2-15.6l-98.2-32.8c-4.8-1.6-10.1-0.9-14.3,1.9l-41.7,27.8c-44.2-21.1-96.6-73.5-117.7-117.7l27.8-41.7c2.8-4.2,3.5-9.4,1.9-14.3l-32.7-98c-2.2-6.6-8.5-11.2-15.6-11.2H69.2C42,75.6,20,97.4,20,124.6C20,313.5,199.4,492,388.3,492L388.3,492z M338.5,224c0-4.2,3.4-7.7,7.7-7.7H385c36.4,0,58.1,10.6,70.4,20.6c2.5,2.1,6,2.4,8.8,0.7s4.2-4.9,3.6-8.1c-14.4-69.3-88.2-74.8-121.7-75.2c-4.2,0-7.6-3.5-7.6-7.7v-30.7c0-3-1.7-5.6-4.3-6.9c-2.6-1.3-5.8-1-8,0.9l-88.5,69.5c-1.8,1.5-3,3.7-3,6s1,4.5,3,6l88.3,69.4c2.4,1.8,5.5,2.2,8.1,0.9c2.7-1.3,4.4-4,4.4-7V224L338.5,224z" />
  </svg>
);

const CallSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M388.4,492c27.1,0,49.2-22,49.2-49.2v-65.6c0-7.1-4.6-13.3-11.2-15.6l-98.2-32.8c-4.8-1.6-10.1-0.9-14.3,1.9l-41.7,27.8C228,337.4,175.6,285,154.5,240.8l27.8-41.7c2.8-4.2,3.5-9.4,1.9-14.3l-32.8-98.2c-2.2-6.7-8.5-11.2-15.6-11.2H69.2c-27.1,0-49.2,21.9-49.2,49C20,313.5,199.5,492,388.4,492L388.4,492z M364.2,224v30.6c0,3,1.7,5.7,4.4,7c2.7,1.3,5.9,1,8.1-0.9l88.3-69.4c1.8-1.5,3-3.7,3-6c0-2.4-1.1-4.6-3-6l-88.3-69.5c-2.3-1.8-5.4-2.1-8.1-0.9c-2.6,1.3-4.3,3.9-4.3,6.9v30.8c0,4.2-3.4,7.6-7.6,7.7c-33.5,0.4-107.3,5.9-121.7,75.2c-0.6,3.2,0.8,6.5,3.6,8.1c2.8,1.7,6.3,1.4,8.8-0.7c12.3-10.1,33.9-20.7,70.4-20.7h38.9C360.8,216.3,364.2,219.8,364.2,224L364.2,224z" />
  </svg>
);

const DoneSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 501 501">
    <path
      d="M250.5,0.5C113,0.5,0.5,113,0.5,250.5s112.5,250,250,250s250-112.5,250-250S388,0.5,250.5,0.5z M376.8,198l-135,135
        c-7.5,8.8-21.2,8.8-30,0l-67.5-67.5c-8.8-8.8-8.8-21.2,0-30s21.2-8.8,30,0l52.5,52.5L348,166.8c8.8-8.8,21.2-8.8,30,0
        C386.7,175.5,385.5,189.2,376.8,198z"
    />
  </svg>
);

const CheckingSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 501 501">
    <path
      d="M250,80.6c-115.6,0-209.7,94.1-209.7,209.7C40.3,405.9,134.4,500,250,500s209.7-94.1,209.7-209.7S365.6,80.6,250,80.6z
         M312.6,352.9c-5.2,5.2-11.9,7.8-18.7,7.8s-13.6-2.6-18.7-7.8l-43.8-43.8c-5-5-7.8-11.7-7.8-18.7V187.2c0-14.6,11.9-26.5,26.5-26.5
        s26.5,11.9,26.5,26.5v92.1l36.1,36.1C322.9,325.8,322.9,342.5,312.6,352.9z M293.8,53h-93.2c-14.6,0-26.5-11.9-26.5-26.5
        S186,0,200.6,0h93.2c14.6,0,26.5,11.9,26.5,26.5S308.5,53,293.8,53z"
    />
  </svg>
);

const PaymentSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
    <path
      d="M367.2,375.2L367.2,375.2c-24,0-43.5-19.4-43.5-43.5v-72.2c0-24,19.4-43.5,43.5-43.5h113.3h2.1v-71.9
        c0-18.5-15-33.5-33.5-33.5H33.5C15,110.7,0,125.6,0,144.2v302.7c0,18.5,15,33.5,33.5,33.5H449c18.5,0,33.5-15,33.5-33.5v-71.9h-2.1
        L367.2,375.2z M480.5,239.8H367.1c-10.8,0-19.6,8.8-19.6,19.6v72.3c0,10.8,8.8,19.6,19.6,19.6h113.3c10.8,0,19.6-8.8,19.6-19.6
        v-72.2C500,248.7,491.3,239.9,480.5,239.8z M406.2,323.9c-15.6,0-28.3-12.7-28.3-28.3s12.7-28.3,28.3-28.3s28.3,12.7,28.3,28.3
        S421.9,323.9,406.2,323.9L406.2,323.9z M390.6,49.3c-7.5-22.7-31.9-35-54.7-27.5l0,0L165.7,78.1h234.4L390.6,49.3z"
    />
  </svg>
);

const ProgressSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
    <path
      d="M250,196c-29.8,0.1-54,24.2-54,54c0.1,29.8,24.2,54,54,54c29.8-0.1,54-24.2,54-54S279.8,196,250,196z M497.1,240.9
            C441.4,165,345.5,87.5,250,87.1C154.3,87.5,58.2,165.6,2.9,240.9c-3.8,5.5-3.8,12.7,0,18.1C58.6,335,154.5,412.5,250,412.9
            c95.7-0.3,191.8-78.4,247.1-153.8C501,253.6,501,246.4,497.1,240.9z M250,348c-54.1,0-98-43.9-98-98s43.9-98,98-98s98,43.9,98,98
            S304.1,348,250,348z"
    />
  </svg>
);

const PlayMarketSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 675 200">
    <g>
      <g>
        <path d="M650,200H25c-13.7,0-25-11.2-25-25V25C0,11.2,11.2,0,25,0h625c13.7,0,25,11.2,25,25v150C675,188.7,663.7,200,650,200z" />
      </g>
      <g>
        <g>
          <path
            fill="#A6A6A6"
            d="M650,4c11.6,0,21,9.4,21,21v150c0,11.6-9.4,21-21,21H25c-11.6,0-21-9.4-21-21V25C4,13.4,13.4,4,25,4H650M650,0H25C11.2,0,0,11.3,0,25v150c0,13.7,11.2,25,25,25h625c13.7,0,25-11.2,25-25V25C675,11.3,663.7,0,650,0L650,0z"
          />
        </g>
      </g>
      <path
        fill="#FFFFFF"
        d="M340.7,108.8c-11.8,0-21.3,8.9-21.3,21.3c0,12.2,9.6,21.3,21.3,21.3c11.8,0,21.3-9,21.3-21.3C362,117.7,352.4,108.8,340.7,108.8z M340.7,142.9c-6.4,0-12-5.3-12-12.9c0-7.7,5.6-12.9,12-12.9s12,5.2,12,12.9C352.7,137.6,347.1,142.9,340.7,142.9z M294.1,108.8c-11.8,0-21.3,8.9-21.3,21.3c0,12.2,9.6,21.3,21.3,21.3c11.8,0,21.3-9,21.3-21.3C315.5,117.7,305.9,108.8,294.1,108.8z M294.1,142.9c-6.4,0-12-5.3-12-12.9c0-7.7,5.6-12.9,12-12.9s12,5.2,12,12.9C306.1,137.6,300.6,142.9,294.1,142.9z M238.7,115.3v9h21.6c-0.6,5.1-2.3,8.8-4.9,11.4c-3.1,3.1-8.1,6.6-16.7,6.6c-13.3,0-23.7-10.7-23.7-24s10.4-24,23.7-24c7.2,0,12.4,2.8,16.3,6.4l6.4-6.4c-5.4-5.2-12.6-9.1-22.6-9.1c-18.2,0-33.5,14.8-33.5,33s15.3,33,33.5,33c9.8,0,17.2-3.2,23-9.3c6-6,7.8-14.3,7.8-21.1c0-2.1-0.2-4-0.5-5.6L238.7,115.3L238.7,115.3z M465.3,122.3c-1.8-4.8-7.2-13.5-18.2-13.5s-20.1,8.6-20.1,21.3c0,11.9,9,21.3,21.1,21.3c9.7,0,15.4-6,17.7-9.4l-7.2-4.8c-2.4,3.5-5.7,5.9-10.5,5.9s-8.1-2.2-10.3-6.4l28.4-11.8L465.3,122.3z M436.3,129.4c-0.2-8.2,6.4-12.4,11.1-12.4c3.7,0,6.8,1.9,7.9,4.5L436.3,129.4z M413.1,150h9.3V87.5h-9.3V150z M397.8,113.5h-0.3c-2.1-2.5-6.1-4.8-11.2-4.8c-10.6,0-20.4,9.3-20.4,21.3c0,11.9,9.7,21.2,20.4,21.2c5.1,0,9.1-2.3,11.2-4.8h0.3v3.1c0,8.1-4.3,12.5-11.4,12.5c-5.7,0-9.3-4.1-10.7-7.6l-8.1,3.4c2.3,5.6,8.5,12.6,18.8,12.6c11,0,20.2-6.4,20.2-22.2V110h-8.9v3.5H397.8z M387.1,142.9c-6.4,0-11.8-5.4-11.8-12.8c0-7.5,5.4-13,11.8-13s11.4,5.5,11.4,13C398.5,137.5,393.5,142.9,387.1,142.9z M509,87.5h-22.4V150h9.3v-23.7h13c10.3,0,20.5-7.5,20.5-19.4S519.4,87.5,509,87.5z M509.3,117.6H496V96.2h13.3c7,0,10.9,5.8,10.9,10.7C520.2,111.8,516.2,117.6,509.3,117.6z M566.9,108.6c-6.8,0-13.8,3-16.6,9.6l8.3,3.5c1.8-3.5,5.1-4.6,8.5-4.6c4.8,0,9.7,2.9,9.8,8v0.6c-1.7-1-5.3-2.4-9.7-2.4c-8.9,0-18,4.9-18,14.1c0,8.4,7.3,13.8,15.5,13.8c6.3,0,9.7-2.8,11.9-6.1h0.3v4.8h9v-24C585.9,114.8,577.6,108.6,566.9,108.6z M565.8,142.9c-3.1,0-7.3-1.5-7.3-5.3c0-4.8,5.3-6.7,9.9-6.7c4.1,0,6,0.9,8.5,2.1C576.2,138.8,571.2,142.9,565.8,142.9z M618.7,110L608,137.1h-0.3L596.6,110h-10.1l16.6,37.9l-9.5,21.1h9.7l25.7-58.9L618.7,110L618.7,110z M534.7,150h9.3V87.5h-9.3V150z"
      />
      <g>
        <linearGradient id="PMGRAD_1" gradientUnits="userSpaceOnUse" x1="108.9994" y1="456.826" x2="25.0878" y2="540.7376" gradientTransform="matrix(1 0 0 1 0 -413.2754)">
          <stop offset="0" style={{ stopColor: "#00A0FF" }} />
          <stop offset="6.574450e-03" style={{ stopColor: "#00A1FF" }} />
          <stop offset="0.2601" style={{ stopColor: "#00BEFF" }} />
          <stop offset="0.5122" style={{ stopColor: "#00D2FF" }} />
          <stop offset="0.7604" style={{ stopColor: "#00DFFF" }} />
          <stop offset="1" style={{ stopColor: "#00E3FF" }} />
        </linearGradient>
        <path fill="url(#PMGRAD_1)" d="M52.2,37.7c-1.5,1.5-2.3,3.9-2.3,7v110.6c0,3.1,0.9,5.5,2.3,7l0.4,0.4l61.9-61.9V100v-0.7l-62-62L52.2,37.7z" />
        <linearGradient id="PMGRAD_2" gradientUnits="userSpaceOnUse" x1="169.1705" y1="513.2754" x2="48.1866" y2="513.2754" gradientTransform="matrix(1 0 0 1 0 -413.2754)">
          <stop offset="0" style={{ stopColor: "#FFE000" }} />
          <stop offset="0.4087" style={{ stopColor: "#FFBD00" }} />
          <stop offset="0.7754" style={{ stopColor: "#FFA500" }} />
          <stop offset="1" style={{ stopColor: "#FF9C00" }} />
        </linearGradient>
        <path fill="url(#PMGRAD_2)" d="M135.1,121.4l-20.6-20.7V100v-0.7l20.7-20.7l0.5,0.3l24.5,13.9c7,4,7,10.5,0,14.4l-24.5,13.9L135.1,121.4z" />
        <linearGradient id="PMGRAD_3" gradientUnits="userSpaceOnUse" x1="124.1266" y1="524.7488" x2="10.3358" y2="638.5397" gradientTransform="matrix(1 0 0 1 0 -413.2754)">
          <stop offset="0" style={{ stopColor: "#FF3A44" }} />
          <stop offset="1" style={{ stopColor: "#C31162" }} />
        </linearGradient>
        <path fill="url(#PMGRAD_3)" d="M135.6,121.1L114.5,100l-62.3,62.3c2.3,2.4,6.1,2.7,10.4,0.3L135.6,121.1" />
        <linearGradient id="PMGRAD_4" gradientUnits="userSpaceOnUse" x1="36.4837" y1="414.1591" x2="87.296" y2="464.9714" gradientTransform="matrix(1 0 0 1 0 -413.2754)">
          <stop offset="0" style={{ stopColor: "32A071" }} />
          <stop offset="6.850000e-02" style={{ stopColor: "#2DA771" }} />
          <stop offset="0.4762" style={{ stopColor: "#15CF74" }} />
          <stop offset="0.8009" style={{ stopColor: "#06E775" }} />
          <stop offset="1" style={{ stopColor: "#00F076" }} />
        </linearGradient>
        <path fill="url(#PMGRAD_4)" d="M135.6,78.9l-73-41.5c-4.3-2.4-8.1-2.1-10.4,0.3l62.3,62.3L135.6,78.9z" />
        <g>
          <path style={{ opacity: "0.2" }} d="M135.1,120.7l-72.6,41.2c-4.1,2.3-7.7,2.2-10,0.1l0,0l-0.4,0.4l0,0l0.4,0.4l0,0c2.3,2.1,6,2.3,10-0.1l73-41.5L135.1,120.7z" />
          <path style={{ opacity: "0.12" }} className="st7" d="M52.2,161.6c-1.5-1.5-2.3-3.9-2.3-7v0.7c0,3.1,0.9,5.5,2.3,7l0.4-0.4L52.2,161.6z" />
        </g>
        <path style={{ opacity: "0.12" }} className="st7" d="M160.1,106.5l-24.9,14.2l0.5,0.5l24.5-13.9c3.5-2,5.2-4.6,5.2-7.2l0,0C165,102.4,163.2,104.7,160.1,106.5z" />
        <path
          style={{ opacity: "0.25" }}
          fill="#FFFFFF"
          d="M62.6,38.1l97.5,55.4c3.2,1.8,4.9,4.1,5.2,6.5l0,0c0-2.6-1.7-5.2-5.2-7.2L62.6,37.4c-7-4-12.7-0.7-12.7,7.3v0.7C49.9,37.4,55.6,34.1,62.6,38.1z"
        />
      </g>
      <g>
        <path
          fill="#FFFFFF"
          stroke="#FFFFFF"
          strokeWidth="0.2"
          strokeMiterlimit="10"
          d="M210.6,71.4h-3.7V61.3h2.9c2.6-2.2,3.9-6.1,3.8-11.5V35h20v26.3h3.3v10.1h-3.7V65h-22.8v6.4H210.6zM217.5,49.8c0.1,4.7-0.9,8.6-2.8,11.5h15.2V38.7h-12.3L217.5,49.8L217.5,49.8z"
        />
        <path
          fill="#FFFFFF"
          stroke="#FFFFFF"
          strokeWidth="0.2"
          strokeMiterlimit="10"
          d="M267.1,61.1c-2.9,3-6.6,4.5-11,4.5s-8.1-1.5-11-4.5s-4.4-6.7-4.4-11.1s1.5-8.1,4.4-11.1s6.6-4.5,11-4.5s8,1.5,11,4.6c3,3,4.4,6.7,4.4,11.1C271.5,54.4,270,58.1,267.1,61.1z M247.9,58.6c2.2,2.2,4.9,3.4,8.1,3.4s5.9-1.1,8.1-3.4c2.2-2.2,3.3-5.1,3.3-8.6s-1.1-6.4-3.3-8.6c-2.2-2.2-4.9-3.4-8.1-3.4c-3.2,0-5.9,1.1-8.1,3.4c-2.2,2.2-3.3,5.1-3.3,8.6C244.6,53.5,245.7,56.4,247.9,58.6z"
        />
        <path
          fill="#FFFFFF"
          stroke="#FFFFFF"
          strokeWidth="0.2"
          strokeMiterlimit="10"
          d="M290.9,65.7c-4.4,0-8.1-1.5-11.1-4.5s-4.5-6.7-4.5-11.2s1.5-8.2,4.5-11.2s6.7-4.5,11.1-4.5c4.6,0,8.2,1.6,11,4.9l-2.7,2.6c-2-2.5-4.8-3.8-8.3-3.8c-3.3,0-6,1.1-8.3,3.3s-3.4,5.1-3.4,8.7s1.1,6.5,3.4,8.7c2.2,2.2,5,3.3,8.3,3.3c3.6,0,6.7-1.5,9.2-4.4l2.7,2.7c-1.4,1.6-3.1,3-5.2,3.9C295.6,65.2,293.3,65.7,290.9,65.7z"
        />
        <path fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="0.2" strokeMiterlimit="10" d="M318.4,65h-3.9V38.7h-8.4V35h20.6v3.7h-8.4L318.4,65L318.4,65z" />
        <path
          fill="#FFFFFF"
          stroke="#FFFFFF"
          strokeWidth="0.2"
          strokeMiterlimit="10"
          d="M353.2,35l-11.4,25.3c-1.6,3.6-3.9,5.4-7,5.4c-0.9,0-1.9-0.2-3-0.7l1-3.6c0.6,0.4,1.3,0.5,2,0.5c0.9,0,1.6-0.2,2.1-0.5s0.9-1,1.4-1.9l1.1-2.4l-10-22.1h4.5l7.4,17.2h0.2l7.2-17.2H353.2z"
        />
        <path fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="0.2" strokeMiterlimit="10" d="M357.6,65V35h21.7v30h-3.9V38.7h-14V65H357.6z" />
        <path fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="0.2" strokeMiterlimit="10" d="M386.2,65V35h3.9v12.9h15V35h3.9v30h-4V51.5h-15V65H386.2z" />
        <path
          fill="#FFFFFF"
          stroke="#FFFFFF"
          strokeWidth="0.2"
          strokeMiterlimit="10"
          d="M440.3,61.1c-2.9,3-6.6,4.5-11,4.5s-8.1-1.5-11-4.5s-4.4-6.7-4.4-11.1s1.5-8.1,4.4-11.1s6.6-4.5,11-4.5s8,1.5,11,4.6c3,3,4.4,6.7,4.4,11.1C444.7,54.4,443.2,58.1,440.3,61.1z M421.1,58.6c2.2,2.2,4.9,3.4,8.1,3.4s5.9-1.1,8.1-3.4c2.2-2.2,3.3-5.1,3.3-8.6s-1.1-6.4-3.3-8.6c-2.2-2.2-4.9-3.4-8.1-3.4s-5.9,1.1-8.1,3.4c-2.2,2.2-3.3,5.1-3.3,8.6C417.8,53.5,418.9,56.4,421.1,58.6z"
        />
        <path
          fill="#FFFFFF"
          stroke="#FFFFFF"
          strokeWidth="0.2"
          strokeMiterlimit="10"
          d="M460.5,65V35h10.8c2.3,0,4.4,0.8,6.1,2.3c1.7,1.6,2.6,3.5,2.6,5.8c0,1.4-0.4,2.7-1.1,3.8s-1.7,1.9-3,2.5v0.2c1.5,0.5,2.7,1.4,3.6,2.6c0.9,1.2,1.4,2.7,1.4,4.3c0,2.5-0.9,4.5-2.7,6.1c-1.8,1.6-3.9,2.4-6.4,2.4C471.8,65,460.5,65,460.5,65zM464.3,47.9h7c1.5,0,2.6-0.5,3.5-1.4c0.9-1,1.3-2,1.3-3.2s-0.4-2.2-1.3-3.1c-0.8-0.9-2-1.4-3.4-1.4h-7.2v9.1H464.3z M464.3,61.3h7.8c1.5,0,2.7-0.5,3.6-1.6c0.9-1,1.4-2.2,1.4-3.4s-0.5-2.4-1.4-3.4s-2.2-1.5-3.7-1.5h-7.6L464.3,61.3L464.3,61.3z"
        />
      </g>
    </g>
  </svg>
);

const AppStoreSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 598.3 200">
    <g>
      <g>
        <g>
          <g>
            <path
              fill="#B7B7B7"
              d="M550.7,0h-503c-1.8,0-3.6,0-5.5,0c-1.5,0-3,0-4.6,0.1c-3.3,0.1-6.7,0.3-10,0.9s-6.5,1.6-9.5,3.1S12.4,7.6,10,10s-4.4,5.1-5.9,8.1c-1.6,3-2.5,6.2-3.1,9.5s-0.8,6.7-0.9,10C0,39.2,0,40.7,0,42.2c0,1.8,0,3.6,0,5.5v104.6c0,1.8,0,3.7,0,5.5c0,1.6,0,3.1,0.1,4.6c0.1,3.3,0.3,6.7,0.9,10s1.6,6.5,3.1,9.5s3.5,5.7,5.9,8.1c2.4,2.4,5.1,4.4,8.1,5.9c3,1.6,6.2,2.5,9.5,3.2c3.3,0.6,6.7,0.8,10,0.9c1.5,0,3.1,0.1,4.6,0.1c1.8,0,3.6,0,5.5,0h503c1.8,0,3.6,0,5.4,0c1.5,0,3.1,0,4.6-0.1c3.3-0.1,6.7-0.3,10-0.9c3.3-0.6,6.5-1.6,9.5-3.2c3-1.5,5.7-3.5,8.1-5.9c2.4-2.3,4.4-5.1,5.9-8.1s2.5-6.2,3.1-9.5s0.8-6.7,0.9-10c0-1.6,0-3.1,0-4.6c0-1.8,0-3.6,0-5.5V47.7c0-1.8,0-3.6,0-5.5c0-1.5,0-3.1,0-4.6c-0.1-3.3-0.3-6.7-0.9-10c-0.6-3.3-1.6-6.5-3.1-9.5s-3.5-5.7-5.9-8.1s-5.1-4.4-8.1-5.9c-3.1-1.5-6.2-2.5-9.5-3.1s-6.7-0.8-10-0.9c-1.5,0-3.1-0.1-4.6-0.1C554.3,0,552.5,0,550.7,0L550.7,0z"
            />
            <path
              fill="#000001"
              d="M42.2,195.6c-1.5,0-3,0-4.5-0.1c-2.8-0.1-6.1-0.2-9.3-0.8c-3.1-0.6-5.8-1.5-8.3-2.7c-2.6-1.3-5-3-7-5.1c-2.1-2-3.8-4.4-5.1-7c-1.3-2.5-2.2-5.2-2.7-8.3c-0.6-3.4-0.8-6.8-0.8-9.4c0-1.1-0.1-4.6-0.1-4.6V42.2c0,0,0-3.5,0.1-4.5c0.1-2.6,0.2-6,0.8-9.4C5.8,25.2,6.7,22.5,8,20c1.3-2.6,3-5,5.1-7c2.1-2.1,4.4-3.8,7-5.1s5.3-2.2,8.3-2.7c3.4-0.6,6.8-0.8,9.4-0.8l4.5-0.1h513.8l4.6,0.1c2.6,0.1,6,0.2,9.3,0.8c3,0.5,5.7,1.4,8.4,2.7c2.6,1.3,4.9,3,7,5.1c2,2,3.8,4.4,5.1,7s2.2,5.3,2.7,8.2c0.6,3.2,0.8,6.4,0.9,9.4c0,1.4,0,2.9,0,4.5c0,1.9,0,3.7,0,5.5v104.6c0,1.8,0,3.6,0,5.4c0,1.6,0,3.1,0,4.6c-0.1,2.9-0.3,6.2-0.9,9.3c-0.5,3.1-1.4,5.8-2.7,8.4c-1.3,2.6-3.1,4.9-5.1,6.9c-2.1,2.1-4.4,3.8-7,5.1s-5.2,2.2-8.3,2.7c-3.2,0.6-6.5,0.7-9.3,0.8c-1.5,0-3,0.1-4.5,0.1h-5.4L42.2,195.6z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill="#FFFFFF"
                d="M123.8,101.5c-0.1-13.8,11.3-20.4,11.8-20.8c-6.4-9.4-16.4-10.7-20-10.8c-8.4-0.9-16.5,5-20.8,5c-4.4,0-10.9-4.9-18-4.8c-9.1,0.1-17.7,5.4-22.4,13.6c-9.7,16.7-2.5,41.3,6.8,54.9c4.6,6.6,10.1,14,17.1,13.8c6.9-0.3,9.5-4.4,17.9-4.4c8.3,0,10.7,4.4,18,4.3c7.4-0.1,12.1-6.7,16.6-13.3c5.4-7.6,7.5-15.1,7.6-15.5C138.3,123.4,124,118,123.8,101.5z"
              />
              <path fill="#FFFFFF" d="M110.2,61.1c3.7-4.7,6.3-11,5.6-17.5c-5.4,0.2-12.2,3.7-16,8.3c-3.4,4-6.5,10.6-5.7,16.8C100.1,69.2,106.3,65.6,110.2,61.1z" />
            </g>
          </g>
          <g>
            <path fill="#FFFFFF" d="M211.5,135.7h-23.7l-5.7,16.8h-10l22.4-62.1H205l22.4,62.1h-10.2L211.5,135.7z M190.3,128h18.8l-9.2-27.2h-0.3L190.3,128z" />
            <path
              fill="#FFFFFF"
              d="M275.8,129.8c0,14.1-7.5,23.1-18.9,23.1c-6.5,0-11.6-2.9-14.2-7.9h-0.2v22.4h-9.3v-60.2h9v7.5h0.2c2.6-4.9,8.1-8,14.4-8C268.2,106.7,275.8,115.8,275.8,129.8z M266.2,129.8c0-9.2-4.7-15.2-12-15.2c-7.1,0-11.9,6.2-11.9,15.2c0,9.1,4.8,15.2,11.9,15.2C261.5,145.1,266.2,139.1,266.2,129.8z"
            />
            <path
              fill="#FFFFFF"
              d="M325.6,129.8c0,14.1-7.5,23.1-18.9,23.1c-6.5,0-11.6-2.9-14.2-7.9h-0.2v22.4H283v-60.2h9v7.5h0.2c2.6-4.9,8.1-8,14.4-8C318,106.7,325.6,115.8,325.6,129.8z M316.1,129.8c0-9.2-4.7-15.2-12-15.2c-7.1,0-11.9,6.2-11.9,15.2c0,9.1,4.8,15.2,11.9,15.2C311.3,145.1,316.1,139.1,316.1,129.8z"
            />
            <path
              fill="#FFFFFF"
              d="M358.6,135.4c0.7,6.2,6.7,10,14.8,10c7.8,0,13.5-4,13.5-9.6c0-4.8-3.4-7.7-11.4-9.7l-8-1.9c-11.4-2.8-16.7-8.1-16.7-16.7c0-10.7,9.3-18.1,22.6-18.1c13.1,0,22.1,7.4,22.4,18.1h-9.4c-0.6-6.2-5.7-9.9-13.2-9.9s-12.6,3.8-12.6,9.3c0,4.4,3.3,7,11.3,9l6.8,1.7c12.7,3,18,8.1,18,17.2c0,11.6-9.3,18.9-24,18.9c-13.8,0-23.1-7.1-23.7-18.3H358.6L358.6,135.4z"
            />
            <path
              fill="#FFFFFF"
              d="M416.7,96.5v10.7h8.6v7.4h-8.6v25c0,3.9,1.7,5.7,5.5,5.7c0.9,0,2.5-0.1,3.1-0.2v7.3c-1,0.3-3.1,0.4-5.2,0.4c-9.2,0-12.7-3.4-12.7-12.2v-25.9h-6.6v-7.4h6.6V96.5H416.7z"
            />
            <path
              fill="#FFFFFF"
              d="M430.3,129.8c0-14.2,8.4-23.2,21.5-23.2s21.5,9,21.5,23.2c0,14.3-8.3,23.2-21.5,23.2C438.6,153,430.3,144.1,430.3,129.8z M463.8,129.8c0-9.8-4.5-15.5-12-15.5s-12,5.8-12,15.5c0,9.8,4.5,15.5,12,15.5S463.8,139.7,463.8,129.8z"
            />
            <path fill="#FFFFFF" d="M480.9,107.2h8.9v7.7h0.2c1.4-5.1,5.6-8.2,10.9-8.2c1.3,0,2.5,0.2,3.2,0.3v8.7c-0.7-0.3-2.4-0.6-4.2-0.6c-6,0-9.7,4-9.7,10.4v26.9h-9.3V107.2z" />
            <path
              fill="#FFFFFF"
              d="M546.9,139.2c-1.2,8.2-9.3,13.9-19.5,13.9c-13.2,0-21.3-8.8-21.3-23s8.2-23.4,21-23.4c12.5,0,20.4,8.6,20.4,22.3v3.2h-32v0.6c0,7.7,4.9,12.8,12.2,12.8c5.2,0,9.2-2.5,10.5-6.4H546.9z M515.5,125.7h22.6c-0.2-6.9-4.6-11.5-11.1-11.5C520.6,114.2,516,118.8,515.5,125.7z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#FFFFFF"
            d="M183.7,56.3h4c3.3,0,5.6-1.9,5.6-4.8c0-2.8-2.1-4.5-5.6-4.5s-5.8,1.8-6,4.7h-4.4c0.3-5.4,4.3-8.7,10.5-8.7c5.9,0,10,3.3,10,8c0,3.3-2.2,6.1-5.4,6.8v0.4c3.9,0.4,6.6,3.1,6.6,7.2c0,5.1-4.8,8.9-11.1,8.9c-6.5,0-10.9-3.5-11.2-8.8h4.4c0.3,2.9,2.9,4.7,6.8,4.7s6.4-2.1,6.4-5c0-3-2.4-4.8-6.5-4.8h-4.1V56.3z"
          />
          <path
            fill="#FFFFFF"
            d="M204.1,67.1c0-4.1,3-6.4,8.4-6.7l6.1-0.4v-1.9c0-2.4-1.6-3.7-4.6-3.7c-2.5,0-4.2,0.9-4.7,2.5H205c0.5-3.9,4.1-6.3,9.2-6.3c5.6,0,8.8,2.8,8.8,7.6v15.4h-4.3v-3.2h-0.4c-1.3,2.3-3.8,3.5-6.8,3.5C207.3,73.9,204.1,71.2,204.1,67.1z M218.6,65.2v-1.9l-5.5,0.4c-3.1,0.2-4.5,1.3-4.5,3.2c0,2,1.8,3.2,4.2,3.2C216.1,70.1,218.6,68,218.6,65.2z"
          />
          <path fill="#FFFFFF" d="M234.8,54.7v18.8h-4.4V51h14.8v3.7H234.8z" />
          <path
            fill="#FFFFFF"
            d="M272.1,62.2c0,7.2-3.6,11.6-9.3,11.6c-3.2,0-5.8-1.4-6.9-3.8h-0.4v11h-4.4V51h4.3v3.7h0.3c1.4-2.6,4-4.1,7.1-4.1C268.5,50.6,272.1,55.1,272.1,62.2z M267.6,62.2c0-4.8-2.3-7.6-6-7.6s-6.1,2.9-6.1,7.6s2.3,7.6,6.1,7.6C265.3,69.9,267.6,67,267.6,62.2z"
          />
          <path
            fill="#FFFFFF"
            d="M278.1,81.6v-3.8c0.4,0.1,1,0.1,1.5,0.1c2.1,0,3.3-0.9,4.1-3.1l0.3-1.1L275.8,51h4.8l5.6,17.9h0.4l5.6-17.9h4.7l-8.4,23.4c-1.9,5.5-4.1,7.2-8.6,7.2C279.5,81.7,278.5,81.6,278.1,81.6z"
          />
          <path
            fill="#FFFFFF"
            d="M300.4,67.1h4.4c0.4,2,2.3,3,4.9,3c3,0,4.8-1.3,4.8-3.3c0-2.2-1.6-3.2-4.8-3.2h-3.4v-3.5h3.3c2.7,0,4.1-1,4.1-2.9c0-1.7-1.3-2.9-4.1-2.9c-2.5,0-4.3,1.1-4.6,2.8h-4.3c0.5-4,3.8-6.6,8.9-6.6c5.4,0,8.4,2.4,8.4,6.2c0,2.3-1.4,4.1-3.6,4.6v0.4c2.9,0.7,4.4,2.6,4.4,5.1c0,4.3-3.6,7.1-9.2,7.1C304.8,73.9,300.8,71.6,300.4,67.1z"
          />
          <path fill="#FFFFFF" d="M325.3,73.5V51h4.4v15.5h0.4L340.5,51h4.4v22.5h-4.4V57.9h-0.3l-10.4,15.6H325.3z" />
          <path fill="#FFFFFF" d="M369.1,54.7H362v18.8h-4.4V54.7h-7.1V51h18.6V54.7z" />
          <path
            fill="#FFFFFF"
            d="M393.1,67.4c-1,4-4.6,6.5-9.8,6.5c-6.5,0-10.4-4.4-10.4-11.6s4-11.8,10.4-11.8c6.3,0,10,4.3,10,11.4v1.6h-15.9v0.2c0.1,3.9,2.4,6.5,6,6.5c2.7,0,4.5-1,5.4-2.7L393.1,67.4L393.1,67.4z M377.4,60.2h11.4c-0.1-3.5-2.3-5.8-5.5-5.8C380,54.3,377.7,56.6,377.4,60.2z"
          />
          <path
            fill="#FFFFFF"
            d="M411.9,51h10.2c4.4,0,7,2.2,7,5.7c0,2.3-1.6,4.3-3.8,4.8v0.4c2.9,0.3,4.8,2.5,4.8,5.2c0,3.9-3,6.5-7.9,6.5h-10.3L411.9,51L411.9,51z M416.3,54.4v5.8h4.4c2.7,0,4-1,4-2.9c0-1.8-1.1-2.9-3.5-2.9C421.2,54.4,416.3,54.4,416.3,54.4zM416.3,63.5v6.6h5.3c2.6,0,4-1.2,4-3.3c0-2.3-1.6-3.3-4.6-3.3C421,63.5,416.3,63.5,416.3,63.5z"
          />
        </g>
      </g>
    </g>
  </svg>
);

const LogoSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 306.2">
    <rect x="258.1" width="75.2" height="75.2" fill="#E70000" />
    <polygon points="319.3,30.5 302.8,30.5 302.8,14 288.7,14 288.7,30.5 272.2,30.5 272.2,44.6 288.7,44.6 288.7,61.1 302.8,61.1 302.8,44.6 319.3,44.6" fill="#FFFFFF" />
    <path
      d="M424.8,231V75.3c0-41.5-33.7-75.2-75.2-75.2v306.1c0,0,33.7,0,75.2,0S500,272.5,500,231H424.8L424.8,231zM166.7,306.2c0,0,33.7,0,75.2,0V91.4h-75.2V306.2z M258.1,306.2c41.5,0,75.2,0,75.2,0V91.4h-75.2L258.1,306.2L258.1,306.2z M0,231v75.2h75.2c41.5,0,75.2-33.7,75.2-75.2v-80.6V75.2h91.5V0h-91.5c-41.5,0-75.2,33.7-75.2,75.2v75.2v5.4V231H0z"
      fill="#448AFF"
    />
  </svg>
);

const EmptySvg = () => (
  <svg viewBox="0 0 49.41 40">
    <path d="M49.294,19.506c0-.01,0-.022-.007-.033L41.168,3.264A5.846,5.846,0,0,0,35.9,0H13.5A5.845,5.845,0,0,0,8.242,3.262L.124,19.473c0,.01,0,.022-.007.033A1.159,1.159,0,0,0,0,20V34.118A5.889,5.889,0,0,0,5.882,40H43.528a5.888,5.888,0,0,0,5.882-5.882V20A1.159,1.159,0,0,0,49.294,19.506ZM10.346,4.314v0a3.509,3.509,0,0,1,3.158-1.958H35.9a3.511,3.511,0,0,1,3.159,1.961l7.265,14.509H34.117a1.176,1.176,0,0,0-.979.524l-4.356,6.535H20.629l-4.356-6.535a1.176,1.176,0,0,0-.979-.524H3.081ZM43.528,37.647H5.882a3.533,3.533,0,0,1-3.529-3.529V21.176H14.664l4.356,6.536a1.18,1.18,0,0,0,.979.524h9.412a1.18,1.18,0,0,0,.979-.524l4.356-6.536H47.057V34.118A3.533,3.533,0,0,1,43.528,37.647Z" />
  </svg>
);

const BudgetUpSvg = () => (
  <svg viewBox="0 0 512 512">
    <g>
      <path d="M400,49.8c-7.7-23.2-32.7-35.8-56-28.2L169.7,79.3h240L400,49.8z" />
      <path d="M492,244.9H375.9c-11.1,0-20.1,9-20.1,20.1v74c0,11.1,9,20.1,20.1,20.1h116c11.1,0,20.1-9,20.1-20.1v-73.9C512,254,503.1,245,492,244.9z M416,331c-16,0-29-13-29-29s13-29,29-29s29,13,29,29S432,331,416,331z" />
      <path d="M376,383.5c-24.6,0-44.5-19.9-44.5-44.5v-73.9c0-24.6,19.9-44.5,44.5-44.5h116h2.1V147c0-18.9-15.4-34.3-34.3-34.3H34.3C15.4,112.7,0,128,0,147v310c0,18.9,15.4,34.3,34.3,34.3h425.5c18.9,0,34.3-15.4,34.3-34.3v-73.6H492L376,383.5z M246,284.8c-1.3,2.7-4,4.4-7,4.4h-30.6c-4.2,0-7.7,3.4-7.8,7.5v38.9c0,36.5,10.6,58.1,20.7,70.4c2.1,2.5,2.4,6,0.7,8.8c-1.6,2.8-4.9,4.2-8.1,3.6c-69.3-14.4-74.8-88.2-75.2-121.7c-0.1-4.2-3.5-7.6-7.7-7.6h-30.8c-3,0-5.6-1.7-6.9-4.3c-1.2-2.7-0.9-5.8,0.9-8.1l69.5-88.3c1.4-1.9,3.6-3,6-3c2.3,0,4.5,1.2,6,3l69.4,88.3C247,278.9,247.3,282.1,246,284.8z" />
    </g>
  </svg>
);

const BudgetDownSvg = () => (
  <svg viewBox="0 0 512 512">
    <g>
      <path d="M400,49.8c-7.7-23.2-32.7-35.8-56-28.2L169.7,79.3h240L400,49.8z" />
      <path d="M492,244.9H375.9c-11.1,0-20.1,9-20.1,20.1v74c0,11.1,9,20.1,20.1,20.1h116c11.1,0,20.1-9,20.1-20.1v-73.9C512,254,503.1,245,492,244.9z M416,331c-16,0-29-13-29-29s13-29,29-29s29,13,29,29S432,331,416,331z" />
      <path d="M376,383.5c-24.6,0-44.5-19.9-44.5-44.5v-73.9c0-24.6,19.9-44.5,44.5-44.5h116h2.1V147c0-18.9-15.4-34.3-34.3-34.3H34.3C15.4,112.7,0,128,0,147v310c0,18.9,15.4,34.3,34.3,34.3h425.5c18.9,0,34.3-15.4,34.3-34.3v-73.6H492L376,383.5z M245.1,327.3l-69.4,88.3c-1.5,1.8-3.7,3-6,3c-2.4,0-4.6-1.1-6-3l-69.5-88.3c-1.8-2.3-2.1-5.4-0.9-8.1c1.3-2.6,3.9-4.3,6.9-4.3H131c4.2,0,7.6-3.4,7.7-7.6c0.4-33.5,5.9-107.3,75.2-121.7c3.2-0.6,6.5,0.8,8.1,3.6c1.7,2.8,1.4,6.3-0.7,8.8c-10.1,12.3-20.7,33.9-20.7,70.4v38.9c0.1,4.1,3.6,7.5,7.8,7.5H239c3,0,5.7,1.7,7,4.4S247,325.1,245.1,327.3z" />
    </g>
  </svg>
);

const SearchSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M328.3,0C226.8,0,144.5,82.2,144.5,183.7c0,44.7,16,85.7,42.6,117.5L149.4,339c-0.1,0.1-0.2,0.3-0.3,0.5  c-18.6-8.8-41.4-6-56.7,9.4l-77.7,77.7c-19.5,19.5-19.5,51.3,0,70.9c19.6,19.6,51.3,19.6,70.9,0l77.7-77.7  c15.4-15.4,18.2-38.2,9.3-56.8c0.1-0.1,0.3-0.2,0.5-0.3l37.7-37.7c31.9,26.6,72.8,42.6,117.5,42.6c101.5,0,183.7-82.2,183.7-183.7  C512,82.2,429.7,0,328.3,0z M328.3,300.6c-64.5,0-116.9-52.4-116.9-116.9c0-64.5,52.4-116.9,116.9-116.9  c64.5,0,116.9,52.4,116.9,116.9C445.1,248.2,392.8,300.6,328.3,300.6z"></path>
  </svg>
);

const ArrowSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <polygon points="24.9,27.9 17.3,20 24.9,12.1 22.9,10 13.2,20 15.3,22.1 15.3,22.1 22.9,30 " />
  </svg>
);

const LaptopSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 470 470">
    <path
      d="M311.4,363.5c0,6.3-2.6,12.3-7,16.7c-4.5,4.4-10.5,6.9-16.8,6.8H182.3c-6.3,0.1-12.3-2.4-16.8-6.8s-7-10.4-7-16.7
      c0-2-0.9-4-2.3-5.4c-1.5-1.4-3.4-2.2-5.5-2.1H0v40.2C0,413.8,14.8,428,32.5,428h405c17.6,0,32.5-14.1,32.5-31.8V356H319.3
      c-2-0.1-4,0.7-5.5,2.1S311.5,361.5,311.4,363.5z M174.5,363.5c0,2,0.9,4,2.3,5.4c1.5,1.4,3.4,2.2,5.5,2.1h105.5c2,0.1,4-0.7,5.5-2.1
      s2.3-3.4,2.3-5.4c0-6.3,2.6-12.3,7-16.7c4.5-4.4,10.5-6.9,16.8-6.8H450V42.1H20V340h130.6c6.3-0.1,12.3,2.4,16.8,6.8
      C171.9,351.2,174.4,357.2,174.5,363.5z M34,317V64.1c0-4.4,3.6-8,8-8h386.9c4.4,0,8,3.6,8,8V317c0,4.4-3.6,8-8,8H42
      C37.6,325,34,321.4,34,317z M50,72.1V309h369.9V72.1H50z M234.9,268.9c-6.6,0-12-5.4-12-12c0-6.6,5.4-12,12-12c6.6,0,12,5.4,12,12
      C247,263.5,241.6,268.9,234.9,268.9z M274.2,229.4c-1.5,1.4-3.6,2.3-5.8,2.3s-4.2-0.9-5.8-2.4c-7.4-7.4-17.2-11.5-27.7-11.5
      s-20.3,4.1-27.7,11.5c-1.5,1.5-3.6,2.4-5.8,2.4s-4.2-0.8-5.8-2.4c-3.2-3.2-3.2-8.4,0-11.6c10.5-10.5,24.4-16.2,39.3-16.2
      c14.9,0,28.8,5.8,39.3,16.3c1.5,1.5,2.4,3.6,2.4,5.8C276.6,225.8,275.8,227.8,274.2,229.4z M305.6,197.9c-1.6,1.6-3.6,2.4-5.8,2.4
      s-4.2-0.9-5.8-2.4c-15.7-15.7-36.7-24.4-59-24.4s-43.3,8.7-59,24.4c-1.6,1.5-3.6,2.4-5.8,2.4s-4.2-0.8-5.8-2.4
      c-3.2-3.2-3.2-8.4,0-11.6c18.8-18.8,43.9-29.2,70.6-29.2s51.8,10.4,70.6,29.2C308.8,189.5,308.8,194.7,305.6,197.9z M337.3,166.1
      c-1.5,1.5-3.5,2.4-5.7,2.4c-2.2,0-4.2-0.9-5.8-2.4c-24.2-24.2-56.5-37.6-90.9-37.6c-34.4,0-66.6,13.3-90.8,37.6
      c-1.5,1.5-3.6,2.4-5.8,2.4c-2.2,0-4.2-0.8-5.8-2.4c-3.2-3.2-3.2-8.4,0-11.6c27.3-27.3,63.7-42.3,102.4-42.3s75.1,15,102.4,42.3
      C340.5,157.7,340.5,162.9,337.3,166.1z"
    />
  </svg>
);

const PresentationSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 398 398">
    <g>
      <path
        d="M260.6,186.3c-0.9,2.5-1.4,6.3-1.4,11.4c0,5.1,0.5,8.9,1.4,11.5c0.9,2.5,2.4,3.8,4.4,3.8c3.9,0,5.8-5.1,5.8-15.2
          c0-10.1-1.9-15.1-5.8-15.1C262.9,182.6,261.5,183.8,260.6,186.3z"
      />
      <path
        d="M266.1,383.7L207,338.5V292h-16v45.8l-59.6,45.9c-2.7,2.1-3.8,5.6-2.7,8.9c1.1,3.2,4.1,5.4,7.5,5.4c1.8,0,3.5-0.6,4.9-1.7
          l57.4-44.2l57.9,44.2c1.4,1.1,3.1,1.6,4.9,1.6c2.5,0,4.8-1.2,6.4-3.1C270.3,391.3,269.6,386.3,266.1,383.7z"
      />
      <path
        d="M203,177.6c3.9,0,5.8-5.1,5.8-15.2c0-10.1-1.9-15.1-5.8-15.1c-2,0-3.5,1.2-4.4,3.7c-0.9,2.5-1.4,6.3-1.4,11.4
          c0,5.1,0.5,8.9,1.4,11.5C199.5,176.4,201,177.6,203,177.6z"
      />
      <path
        d="M142.8,210.5c4.4,0,7.5-2.4,9.4-7.1c1.9-4.8,2.9-12.5,2.9-23.2c0-10.8-1-18.6-2.9-23.4c-2-4.7-5.1-7.1-9.4-7.1
          c-4.4,0-7.5,2.4-9.4,7.1c-1.9,4.7-2.8,12.5-2.8,23.4c0,10.8,0.9,18.6,2.8,23.3C135.2,208.1,138.4,210.5,142.8,210.5z"
      />
      <path
        d="M370.2,0H27.8C19.1,0,12,7.1,12,15.8v31.4C12,55.9,19.1,63,27.8,63h342.4c8.7,0,15.8-7.1,15.8-15.8V15.8
          C386,7.1,378.9,0,370.2,0z"
      />
      <path
        d="M36,262.8c0,11.3,9.5,20.2,20.8,20.2h283.9c5.4,0.1,10.6-2.1,14.4-5.9s5.9-9,5.9-14.3V79H36V262.8z M280.5,177.1
          c3.6,4.8,5.5,11.6,5.5,20.5c0,9.2-1.8,16.2-5.4,20.8c-3.6,4.7-8.9,7-15.8,7c-6.7,0-11.8-2.4-15.4-7.2c-3.6-4.8-5.4-11.7-5.4-20.7
          c0-18.4,7-27.6,20.9-27.6C271.7,169.9,276.9,172.3,280.5,177.1z M265.7,135.9l-49.1,88.4h-14.5l49.1-88.4H265.7z M202.9,134.6
          c6.8,0,12,2.4,15.7,7.2c3.6,4.8,5.5,11.6,5.5,20.5c0,9.3-1.8,16.2-5.4,20.9c-3.6,4.7-8.9,7-15.8,7c-6.7,0-11.8-2.4-15.4-7.2
          c-3.6-4.8-5.4-11.7-5.4-20.7C182,143.8,189,134.6,202.9,134.6z M119.5,145.6c5-7.4,12.8-11.1,23.3-11.1c10.2,0,17.9,3.9,23.1,11.6
          c5.2,7.7,7.8,19.1,7.8,34c0,15.4-2.5,26.9-7.6,34.3c-5.1,7.4-12.9,11.1-23.4,11.1c-10.2,0-17.9-3.8-23.1-11.5
          c-5.2-7.7-7.8-19-7.8-33.9C112,164.5,114.5,153,119.5,145.6z"
      />
    </g>
  </svg>
);

const RubleSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 442 442">
    <path
      d="M347,32c-0.1-17.7-14.4-31.9-32-32H126.5C108.9,0,95,14.3,95,32v18h252V32z M245.5,33h-49c-4.4,0-8-3.6-8-8s3.6-8,8-8h49
      c4.4,0,8,3.6,8,8S249.9,33,245.5,33z M95,371v39c-0.1,8.4,3.2,16.5,9.1,22.5s14,9.4,22.4,9.5h189c8.5,0.1,16.6-3.3,22.6-9.4
      s9.4-14.3,9.4-22.8V371H95z M275.5,411h-109c-4.4,0-8-3.6-8-8s3.6-8,8-8h109c4.4,0,8,3.6,8,8S279.9,411,275.5,411z M240.1,149.6
      h-47.9v47.9h-16v16h16v16h-16v16h16v31.9h16v-31.9h39.9v-16h-39.9v-16h31.9c17.6,0,31.9-14.5,31.9-32S257.7,149.6,240.1,149.6z
       M240.1,197.5h-31.9v-31.9h31.9c8.8,0,16,7.1,16,15.9S248.9,197.5,240.1,197.5z M347.1,66H95v289h252.4L347.1,66z M289.6,278.9
      c-18.4,18.4-42.7,28.5-68.4,28.5s-50-10.1-68.4-28.5c-18.4-18.4-28.5-42.7-28.5-68.4s10.1-50,28.5-68.4
      c18.4-18.4,42.7-28.5,68.4-28.5s50,10.1,68.4,28.5c18.4,18.4,28.5,42.7,28.5,68.4S308,260.5,289.6,278.9z"
    />
  </svg>
);

const CookieSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <g>
      <g>
        <path
          d="M500.983,181.442l-2.263-7.493l-7.567,2.007c-4.781,1.269-9.426,1.885-14.198,1.885
			c-31.193,0-56.572-25.377-56.572-56.572c0-2.376,0.187-4.789,0.554-7.176l0.862-5.601l-4.967-2.727
			c-6.478-3.558-12.204-8.5-17.017-14.688l-6.405-8.235l-6.389,8.248c-10.871,14.034-27.199,22.083-44.795,22.083
			c-31.193,0-56.573-25.378-56.573-56.573c0-14.778,5.77-28.849,16.247-39.624L312.81,5.758l-15.458-2.427
			C283.276,1.121,269.363,0,256.001,0c-141.159,0-256,114.841-256,256s114.841,256,256,256s256-114.841,255.998-256.002
			C511.999,230.737,508.293,205.654,500.983,181.442z M256.001,495.805C123.773,495.805,16.197,388.229,16.197,256
			S123.773,16.195,256.001,16.195c8.105,0,16.439,0.442,24.903,1.319c-7.449,11.641-11.444,25.112-11.444,39.086
			c0,40.125,32.643,72.768,72.768,72.768c19.409,0,37.606-7.596,51.201-21.117c3.369,3.346,7.008,6.309,10.898,8.871
			c-0.092,1.386-0.138,2.772-0.138,4.148c0,40.124,32.644,72.767,72.767,72.767c3.559,0,7.056-0.262,10.554-0.795
			c5.506,20.474,8.294,41.549,8.294,62.756C495.806,388.228,388.229,495.805,256.001,495.805z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M175.163,113.174c-25.266,0-45.821,20.555-45.821,45.821s20.555,45.821,45.821,45.821
			c25.267,0,45.821-20.555,45.821-45.821S200.429,113.174,175.163,113.174z M175.163,188.619c-16.335,0-29.626-13.291-29.626-29.626
			s13.29-29.626,29.626-29.626c16.336,0,29.626,13.291,29.626,29.626S191.498,188.619,175.163,188.619z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M115.883,210.178c-19.322,0-35.044,15.721-35.044,35.044c0,19.322,15.721,35.044,35.044,35.044
			c19.323,0,35.044-15.721,35.044-35.044C150.926,225.899,135.205,210.178,115.883,210.178z M115.883,264.07
			c-10.393,0-18.848-8.455-18.848-18.848c0-10.393,8.455-18.848,18.848-18.848c10.393,0,18.848,8.455,18.848,18.848
			C134.731,255.615,126.276,264.07,115.883,264.07z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M385.341,296.404c-19.322,0-35.044,15.721-35.044,35.044s15.721,35.044,35.044,35.044
			c19.323,0,35.044-15.721,35.044-35.044S404.663,296.404,385.341,296.404z M385.341,350.296c-10.393,0-18.848-8.455-18.848-18.848
			c0-10.393,8.455-18.848,18.848-18.848s18.848,8.455,18.848,18.848C404.189,341.841,395.734,350.296,385.341,350.296z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M309.894,361.075c-19.322,0-35.044,15.721-35.044,35.044c0,19.322,15.721,35.044,35.044,35.044
			s35.044-15.721,35.044-35.044C344.938,376.796,329.216,361.075,309.894,361.075z M309.894,414.967
			c-10.393,0-18.848-8.455-18.848-18.848c0-10.393,8.455-18.848,18.848-18.848c10.393,0,18.848,8.455,18.848,18.848
			C328.742,406.512,320.287,414.967,309.894,414.967z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M288.337,264.07c-19.322,0-35.044,15.721-35.044,35.044c0,19.322,15.721,35.044,35.044,35.044
			c19.322,0,35.044-15.721,35.044-35.044C323.381,279.791,307.659,264.07,288.337,264.07z M288.337,317.962
			c-10.393,0-18.848-8.455-18.848-18.848c0-10.393,8.455-18.848,18.848-18.848c10.393,0,18.848,8.455,18.848,18.848
			C307.185,309.506,298.73,317.962,288.337,317.962z"
        />
      </g>
    </g>
    <g>
      <g>
        <rect x="304.507" y="177.847" width="21.557" height="16.195" />
      </g>
    </g>
    <g>
      <g>
        <rect x="336.844" y="210.173" width="21.556" height="16.195" />
      </g>
    </g>
    <g>
      <g>
        <rect x="347.62" y="167.061" width="21.557" height="16.195" />
      </g>
    </g>
    <g>
      <g>
        <rect x="99.711" y="371.858" width="21.557" height="16.195" />
      </g>
    </g>
    <g>
      <g>
        <rect x="121.272" y="339.521" width="21.557" height="16.195" />
      </g>
    </g>
    <g>
      <g>
        <rect x="142.823" y="371.858" width="21.557" height="16.195" />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

const PlayBtnSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 301.8 211.1">
    <path d="M32.8,204.7c24.2,6.4,118.1,6.4,118.1,6.4s94.4,0,118.1-5.9c12.8-3.2,22.8-13.7,26.4-26.4  c6.4-23.9,6.4-72.6,6.4-72.6s0-49.2-6.4-73.4C292.2,20,281.7,10,269,6.4C245.3,0,150.9,0,150.9,0S56.5,0,32.8,6.4  C20,10,10,20.5,6.4,33.3C0,57,0,105.8,0,105.8s0,49.2,6.4,72.5C9.6,191.1,20.1,201.1,32.8,204.7z M120.8,60.6l78.4,45.1l-78.4,45.1  C120.8,150.8,120.8,60.6,120.8,60.6z"></path>
  </svg>
);

const MoonSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
    <path
      d="M13.607,3a.877.877,0,0,0-.153.014,11.459,11.459,0,0,0,1.6,22.734c.144.005.287,0,.43,0a11.438,11.438,0,0,0,9.364-4.861.883.883,0,0,0-.685-1.369A11.445,11.445,0,0,1,14.4,4.208.888.888,0,0,0,13.607,3Z"
      transform="translate(-0.5 -0.375)"
    />
    <rect width="28" height="28" fill="none" />
  </svg>
);

const SunSvg = () => (
  <svg id="brightness-contrast" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <rect width="1.75" height="2.625" transform="translate(13.125 1.75)" />
    <rect width="2.625" height="1.75" transform="translate(23.625 13.125)" />
    <rect width="1.75" height="2.625" transform="translate(13.125 23.625)" />
    <rect width="2.625" height="1.75" transform="translate(1.75 13.125)" />
    <rect width="1.75" height="2.625" transform="translate(4.735 6.011) rotate(-45)" />
    <rect width="2.625" height="1.75" transform="translate(20.128 6.596) rotate(-45)" />
    <rect width="1.75" height="2.625" transform="translate(20.164 21.364) rotate(-45)" />
    <path d="M5.5,24.837,7.338,23l1.225,1.225L6.725,26.063Z" transform="translate(-0.688 -2.875)" />
    <rect width="28" height="28" fill="none" />
    <path d="M15,8a7,7,0,1,0,7,7A7.021,7.021,0,0,0,15,8Zm0,12.25A5.25,5.25,0,1,1,20.25,15,5.265,5.265,0,0,1,15,20.25Z" transform="translate(-1 -1)" />
  </svg>
);

const SmileSvg = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM8.39747 15.5534C8.64413 15.2206 9.11385 15.1508 9.44661 15.3975C10.175 15.9373 11.0541 16.25 12 16.25C12.9459 16.25 13.825 15.9373 14.5534 15.3975C14.8862 15.1508 15.3559 15.2206 15.6025 15.5534C15.8492 15.8862 15.7794 16.3559 15.4466 16.6025C14.4742 17.3233 13.285 17.75 12 17.75C10.715 17.75 9.5258 17.3233 8.55339 16.6025C8.22062 16.3559 8.15082 15.8862 8.39747 15.5534Z"
    />
    <path d="M16 10.5C16 11.3284 15.5523 12 15 12C14.4477 12 14 11.3284 14 10.5C14 9.67157 14.4477 9 15 9C15.5523 9 16 9.67157 16 10.5Z" />
    <path d="M10 10.5C10 11.3284 9.55229 12 9 12C8.44772 12 8 11.3284 8 10.5C8 9.67157 8.44772 9 9 9C9.55229 9 10 9.67157 10 10.5Z" />
  </svg>
);

const ArchiveSvg = () => (
  <svg viewBox="0 0 55 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M40.9833 38.0713V22.2544C40.8724 22.2636 40.7614 22.2698 40.6504 22.2698H14.3495C14.2385 22.2698 14.1245 22.2636 14.0166 22.2544V38.0713C14.0166 39.0916 14.8458 39.9209 15.8662 39.9209H39.1338C40.1541 39.9209 40.9833 39.0947 40.9833 38.0713ZM33.6775 28.3487C33.6775 28.8604 33.2645 29.2735 32.7527 29.2735H22.2472C21.7355 29.2735 21.3224 28.8604 21.3224 28.3487V25.895C21.3224 25.3832 21.7355 24.9702 22.2472 24.9702H32.7497C33.2614 24.9702 33.6744 25.3832 33.6744 25.895V28.3487H33.6775Z"
        fill="white"
      />
      <path
        d="M42.5 18.5706V16.9769C42.5 15.9566 41.6708 15.1273 40.6504 15.1273H14.3496C13.3292 15.1273 12.5 15.9566 12.5 16.9769V18.5706C12.5 19.4769 13.1535 20.2322 14.0166 20.3894C14.1245 20.4079 14.2355 20.4202 14.3496 20.4202H40.6474C40.7615 20.4202 40.8724 20.4079 40.9803 20.3894C41.8465 20.2322 42.5 19.4769 42.5 18.5706Z"
        fill="white"
      />
    </g>
    <defs></defs>
  </svg>
);

const VideoSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19" fill="none">
    <path d="M6.38241 1.85743H11.6175C11.7919 1.85738 11.9255 1.85735 12.0424 1.86878C12.8732 1.95006 13.5533 2.4496 13.8417 3.1225H4.1582C4.44659 2.4496 5.12666 1.95006 5.95752 1.86878C6.07437 1.85735 6.20805 1.85738 6.38241 1.85743Z" />
    <path d="M4.7329 3.89977C3.68993 3.89977 2.83473 4.52958 2.54933 5.36511C2.54339 5.38252 2.53768 5.40003 2.53223 5.41762C2.83084 5.32719 3.14162 5.26812 3.45621 5.22779C4.2665 5.12391 5.2905 5.12396 6.48002 5.12403H11.6491C12.8386 5.12396 13.8626 5.12391 14.6729 5.22779C14.9875 5.26812 15.2983 5.32719 15.5969 5.41762C15.5915 5.40003 15.5858 5.38252 15.5798 5.36511C15.2944 4.52958 14.4392 3.89977 13.3962 3.89977H4.7329Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4957 6.01395H6.50429C3.97319 6.01395 2.70763 6.01395 1.99674 6.75408C1.28585 7.4942 1.45311 8.63765 1.78763 10.9246L2.10486 13.0932C2.3672 14.8867 2.49836 15.7834 3.17126 16.3204C3.84415 16.8574 4.8366 16.8574 6.82151 16.8574H11.1784C13.1634 16.8574 14.1559 16.8574 14.8288 16.3204C15.5017 15.7834 15.6328 14.8867 15.8951 13.0932L16.2124 10.9246C16.5469 8.63772 16.7141 7.49419 16.0033 6.75408C15.2923 6.01395 14.0268 6.01395 11.4957 6.01395ZM10.9359 12.2031C11.3547 11.9435 11.3547 11.2713 10.9359 11.0118L8.4072 9.44412C8.00018 9.19182 7.5 9.52025 7.5 10.0398V13.175C7.5 13.6946 8.00018 14.023 8.4072 13.7707L10.9359 12.2031Z"
    />
  </svg>
);

export const MailIcon = (props) => <Icon component={MailSvg} {...props} />;
export const LockIcon = (props) => <Icon component={LockSvg} {...props} />;
export const UserIcon = (props) => <Icon component={UserSvg} {...props} />;
export const PhoneIcon = (props) => <Icon component={PhoneSvg} {...props} />;
export const WalletIcon = (props) => <Icon component={WalletSvg} {...props} />;

export const ProfileUserIcon = (props) => <Icon component={ProfileUserSvg} {...props} />;
export const MedalDoneIcon = (props) => <Icon component={MedalDoneSvg} {...props} />;
export const PlusIcon = (props) => <Icon component={PlusSvg} {...props} />;
export const CrossIcon = (props) => <Icon component={CrossSvg} {...props} />;
export const CloseIcon = (props) => <Icon component={CloseSvg} {...props} />;
export const CheckIcon = (props) => <Icon component={CheckSvg} {...props} />;

export const ArrowFullIcon = (props) => <Icon component={ArrowFullSvg} {...props} />;
export const EditIcon = (props) => <Icon component={EditSvg} {...props} />;
export const DeleteIcon = (props) => <Icon component={DeleteSvg} {...props} />;
export const ShowIcon = (props) => <Icon component={ShowSvg} {...props} />;

export const PassportIcon = (props) => <Icon component={PassportSvg} {...props} />;
export const CertificateIcon = (props) => <Icon component={CertificateSvg} {...props} />;
export const DiplomaIcon = (props) => <Icon component={DiplomaSvg} {...props} />;

export const FacebookIcon = (props) => <Icon component={FacebookSvg} {...props} />;
export const InstagramIcon = (props) => <Icon component={InstagramSvg} {...props} />;
export const VkIcon = (props) => <Icon component={VkSvg} {...props} />;
export const YoutubeIcon = (props) => <Icon component={YoutubeSvg} {...props} />;
export const TelegramIcon = (props) => <Icon component={TelegramSvg} {...props} />;
export const TwitterIcon = (props) => <Icon component={TwitterSvg} {...props} />;
export const YandexZenIcon = (props) => <Icon component={YandexZenSvg} {...props} />;
export const OkIcon = (props) => <Icon component={OkSvg} {...props} />;

export const WarningIcon = (props) => <Icon component={WarningSvg} {...props} />;
export const InfoIcon = (props) => <Icon component={InfoSvg} {...props} />;
export const SuccessIcon = (props) => <Icon component={SuccessSvg} {...props} />;
export const ErrorIcon = (props) => <Icon component={ErrorSvg} {...props} />;

export const ClipIcon = (props) => <Icon component={ClipSvg} {...props} />;
export const MessageIcon = (props) => <Icon component={MessageSvg} {...props} />;
export const ChatIcon = (props) => <Icon component={ChatSvg} {...props} />;
export const CallIcon = (props) => <Icon component={CallSvg} {...props} />;
export const OrderCallIcon = (props) => <Icon component={OrderCallSvg} {...props} />;

export const DocumentIcon = (props) => <Icon component={DocumentSvg} {...props} />;

export const DoneIcon = (props) => <Icon component={DoneSvg} {...props} />;
export const CheckingIcon = (props) => <Icon component={CheckingSvg} {...props} />;
export const PaymentIcon = (props) => <Icon component={PaymentSvg} {...props} />;
export const ProgressIcon = (props) => <Icon component={ProgressSvg} {...props} />;

export const PlayMarketIcon = (props) => <Icon component={PlayMarketSvg} {...props} />;
export const AppStoreIcon = (props) => <Icon component={AppStoreSvg} {...props} />;

export const LogoIcon = (props) => <Icon component={LogoSvg} {...props} />;

export const EmptyIcon = (props) => <Icon component={EmptySvg} {...props} />;

export const BudgetUpIcon = (props) => <Icon component={BudgetUpSvg} {...props} />;
export const BudgetBottomIcon = (props) => <Icon component={BudgetDownSvg} {...props} />;

export const SearchIcon = (props) => <Icon component={SearchSvg} {...props} />;

export const ArrowIcon = (props) => <Icon component={ArrowSvg} {...props} />;

export const loadingIcon = <LoadingOutlined style={{ fontSize: 20, color: "white" }} spin />;

export const LaptopIcon = (props) => <Icon component={LaptopSvg} {...props} />;
export const PresentationIcon = (props) => <Icon component={PresentationSvg} {...props} />;
export const RubleIcon = (props) => <Icon component={RubleSvg} {...props} />;

export const CookieIcon = (props) => <Icon component={CookieSvg} {...props} />;

export const PlayBtnIcon = (props) => <Icon component={PlayBtnSvg} {...props} />;
export const VideoIcon = (props) => <Icon component={VideoSvg} {...props} />;

export const MoonIcon = (props) => <Icon component={MoonSvg} {...props} />;
export const SunIcon = (props) => <Icon component={SunSvg} {...props} />;

export const SmileIcon = (props) => <Icon component={SmileSvg} {...props} />;
export const ArchiveIcon = (props) => <Icon component={ArchiveSvg} {...props} />;
